var p = Object.defineProperty, F = Object.defineProperties;
var u = Object.getOwnPropertyDescriptors;
var L = Object.getOwnPropertySymbols;
var C = Object.prototype.hasOwnProperty, v = Object.prototype.propertyIsEnumerable;
var m = (r, e, d) => e in r ? p(r, e, { enumerable: !0, configurable: !0, writable: !0, value: d }) : r[e] = d, s = (r, e) => {
  for (var d in e || (e = {}))
    C.call(e, d) && m(r, d, e[d]);
  if (L)
    for (var d of L(e))
      v.call(e, d) && m(r, d, e[d]);
  return r;
}, n = (r, e) => F(r, u(e));
var g = (r, e) => {
  var d = {};
  for (var l in r)
    C.call(r, l) && e.indexOf(l) < 0 && (d[l] = r[l]);
  if (r != null && L)
    for (var l of L(r))
      e.indexOf(l) < 0 && v.call(r, l) && (d[l] = r[l]);
  return d;
};
import { jsx as t, jsxs as M } from "react/jsx-runtime";
import f from "react";
import { r as o } from "../../rem-CMQJ_ZTp.js";
const v2 = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: d ? "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336l24 0 0-64-24 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 88 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-208a32 32 0 1 1 0 64 32 32 0 1 1 0-64z" : "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336c-13.3 0-24 10.7-24 24s10.7 24 24 24l80 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0-88c0-13.3-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l24 0 0 64-24 0zm40-144a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
        }
      )
    })
  );
}), M2 = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: d ? "M256 32c14.2 0 27.3 7.5 34.5 19.8l216 368c7.3 12.4 7.3 27.7 .2 40.1S486.3 480 472 480L40 480c-14.3 0-27.6-7.7-34.7-20.1s-7-27.8 .2-40.1l216-368C228.7 39.5 241.8 32 256 32zm0 128c-13.3 0-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z" : "M248.4 84.3c1.6-2.7 4.5-4.3 7.6-4.3s6 1.6 7.6 4.3L461.9 410c1.4 2.3 2.1 4.9 2.1 7.5c0 8-6.5 14.5-14.5 14.5l-387 0c-8 0-14.5-6.5-14.5-14.5c0-2.7 .7-5.3 2.1-7.5L248.4 84.3zm-41-25L9.1 385c-6 9.8-9.1 21-9.1 32.5C0 452 28 480 62.5 480l387 0c34.5 0 62.5-28 62.5-62.5c0-11.5-3.2-22.7-9.1-32.5L304.6 59.3C294.3 42.4 275.9 32 256 32s-38.3 10.4-48.6 27.3zM288 368a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-8-184c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 96c0 13.3 10.7 24 24 24s24-10.7 24-24l0-96z"
        }
      )
    })
  );
}), z2 = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: d ? "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c13.3 0 24 10.7 24 24l0 112c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-112c0-13.3 10.7-24 24-24zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z" : "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c-13.3 0-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"
        }
      )
    })
  );
}), p2 = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200zm101.8-262.2L295.6 256l62.2 62.2c4.7 4.7 4.7 12.3 0 17l-22.6 22.6c-4.7 4.7-12.3 4.7-17 0L256 295.6l-62.2 62.2c-4.7 4.7-12.3 4.7-17 0l-22.6-22.6c-4.7-4.7-4.7-12.3 0-17l62.2-62.2-62.2-62.2c-4.7-4.7-4.7-12.3 0-17l22.6-22.6c4.7-4.7 12.3-4.7 17 0l62.2 62.2 62.2-62.2c4.7-4.7 12.3-4.7 17 0l22.6 22.6c4.7 4.7 4.7 12.3 0 17z"
        }
      )
    })
  );
}), F2 = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 384 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M345 137c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-119 119L73 103c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l119 119L39 375c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l119-119L311 409c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-119-119L345 137z"
        }
      )
    })
  );
}), u2 = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M256 0c17 0 33.6 1.7 49.8 4.8c7.9 1.5 21.8 6.1 29.4 20.1c2 3.7 3.6 7.6 4.6 11.8l9.3 38.5C350.5 81 360.3 86.7 366 85l38-11.2c4-1.2 8.1-1.8 12.2-1.9c16.1-.5 27 9.4 32.3 15.4c22.1 25.1 39.1 54.6 49.9 86.3c2.6 7.6 5.6 21.8-2.7 35.4c-2.2 3.6-4.9 7-8 10L459 246.3c-4.2 4-4.2 15.5 0 19.5l28.7 27.3c3.1 3 5.8 6.4 8 10c8.2 13.6 5.2 27.8 2.7 35.4c-10.8 31.7-27.8 61.1-49.9 86.3c-5.3 6-16.3 15.9-32.3 15.4c-4.1-.1-8.2-.8-12.2-1.9L366 427c-5.7-1.7-15.5 4-16.9 9.8l-9.3 38.5c-1 4.2-2.6 8.2-4.6 11.8c-7.7 14-21.6 18.5-29.4 20.1C289.6 510.3 273 512 256 512s-33.6-1.7-49.8-4.8c-7.9-1.5-21.8-6.1-29.4-20.1c-2-3.7-3.6-7.6-4.6-11.8l-9.3-38.5c-1.4-5.8-11.2-11.5-16.9-9.8l-38 11.2c-4 1.2-8.1 1.8-12.2 1.9c-16.1 .5-27-9.4-32.3-15.4c-22-25.1-39.1-54.6-49.9-86.3c-2.6-7.6-5.6-21.8 2.7-35.4c2.2-3.6 4.9-7-8-10L53 265.7c4.2-4 4.2-15.5 0-19.5L24.2 218.9c-3.1-3-5.8-6.4-8-10C8 195.3 11 181.1 13.6 173.6c10.8-31.7 27.8-61.1 49.9-86.3c5.3-6 16.3-15.9 32.3-15.4c4.1 .1 8.2 .8 12.2 1.9L146 85c5.7 1.7 15.5-4 16.9-9.8l9.3-38.5c1-4.2 2.6-8.2 4.6-11.8c7.7-14 21.6-18.5 29.4-20.1C222.4 1.7 239 0 256 0zM218.1 51.4l-8.5 35.1c-7.8 32.3-45.3 53.9-77.2 44.6L97.9 120.9c-16.5 19.3-29.5 41.7-38 65.7l26.2 24.9c24 22.8 24 66.2 0 89L59.9 325.4c8.5 24 21.5 46.4 38 65.7l34.6-10.2c31.8-9.4 69.4 12.3 77.2 44.6l8.5 35.1c24.6 4.5 51.3 4.5 75.9 0l8.5-35.1c7.8-32.3 45.3-53.9 77.2-44.6l34.6 10.2c16.5-19.3 29.5-41.7 38-65.7l-26.2-24.9c-24-22.8-24-66.2 0-89l26.2-24.9c-8.5-24-21.5-46.4-38-65.7l-34.6 10.2c-31.8 9.4-69.4-12.3-77.2-44.6l-8.5-35.1c-24.6-4.5-51.3-4.5-75.9 0zM208 256a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm48 96a96 96 0 1 1 0-192 96 96 0 1 1 0 192z"
        }
      )
    })
  );
}), x2 = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 448 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M304 128a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM49.3 464l349.5 0c-8.9-63.3-63.3-112-129-112l-91.4 0c-65.7 0-120.1 48.7-129 112zM0 482.3C0 383.8 79.8 304 178.3 304l91.4 0C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7L29.7 512C13.3 512 0 498.7 0 482.3z"
        }
      )
    })
  );
}), A2 = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 448 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M441 103c9.4 9.4 9.4 24.6 0 33.9L177 401c-9.4 9.4-24.6 9.4-33.9 0L7 265c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l119 119L407 103c9.4-9.4 24.6-9.4 33.9 0z"
        }
      )
    })
  );
}), y2 = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M368 208A160 160 0 1 0 48 208a160 160 0 1 0 320 0zM337.1 371.1C301.7 399.2 256.8 416 208 416C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208c0 48.8-16.8 93.7-44.9 129.1L505 471c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L337.1 371.1z"
        }
      )
    })
  );
}), I2 = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 576 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: d ? "M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z" : "M287.9 0c9.2 0 17.6 5.2 21.6 13.5l68.6 141.3 153.2 22.6c9 1.3 16.5 7.6 19.3 16.3s.5 18.1-5.9 24.5L433.6 328.4l26.2 155.6c1.5 9-2.2 18.1-9.7 23.5s-17.3 6-25.3 1.7l-137-73.2L151 509.1c-8.1 4.3-17.9 3.7-25.3-1.7s-11.2-14.5-9.7-23.5l26.2-155.6L31.1 218.2c-6.5-6.4-8.7-15.9-5.9-24.5s10.3-14.9 19.3-16.3l153.2-22.6L266.3 13.5C270.4 5.2 278.7 0 287.9 0zm0 79L235.4 187.2c-3.5 7.1-10.2 12.1-18.1 13.3L99 217.9 184.9 303c5.5 5.5 8.1 13.3 6.8 21L171.4 443.7l105.2-56.2c7.1-3.8 15.6-3.8 22.6 0l105.2 56.2L384.2 324.1c-1.3-7.7 1.2-15.5 6.8-21l85.9-85.1L358.6 200.5c-7.8-1.2-14.6-6.1-18.1-13.3L287.9 79z"
        }
      )
    })
  );
}), R2 = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 448 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M224 0c-17.7 0-32 14.3-32 32l0 19.2C119 66 64 130.6 64 208l0 25.4c0 45.4-15.5 89.5-43.8 124.9L5.3 377c-5.8 7.2-6.9 17.1-2.9 25.4S14.8 416 24 416l400 0c9.2 0 17.6-5.3 21.6-13.6s2.9-18.2-2.9-25.4l-14.9-18.6C399.5 322.9 384 278.8 384 233.4l0-25.4c0-77.4-55-142-128-156.8L256 32c0-17.7-14.3-32-32-32zm0 96c61.9 0 112 50.1 112 112l0 25.4c0 47.9 13.9 94.6 39.7 134.6L72.3 368C98.1 328 112 281.3 112 233.4l0-25.4c0-61.9 50.1-112 112-112zm64 352l-64 0-64 0c0 17 6.7 33.3 18.7 45.3s28.3 18.7 45.3 18.7s33.3-6.7 45.3-18.7s18.7-28.3 18.7-45.3z"
        }
      )
    })
  );
}), B2 = f.forwardRef(() => /* @__PURE__ */ M("svg", { width: "36", height: "36", viewBox: "0 0 36 36", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ t("mask", { id: "mask0_14311_32184", style: { maskType: "alpha" }, maskUnits: "userSpaceOnUse", x: "8", y: "9", width: "28", height: "19", children: /* @__PURE__ */ t("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M8.52236 9.95036H36V27.117H8.52236V9.95036Z", fill: "white" }) }),
  /* @__PURE__ */ t("g", { mask: "url(#mask0_14311_32184)", children: /* @__PURE__ */ t("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M35.6003 25.4109C31.5776 22.5915 26.5528 21.7033 21.8139 22.9747L18.1565 23.9557C18.1564 23.9557 18.1564 23.9558 18.1563 23.9558C17.1525 24.2246 16.1392 24.227 15.1906 24.0085C13.0381 23.5127 11.2198 21.8743 10.6096 19.5941C10.1835 18.0026 10.4023 16.3404 11.2254 14.9135C12.0483 13.4868 13.3773 12.4661 14.967 12.0395C15.498 11.8972 16.0367 11.827 16.5719 11.827C17.6395 11.827 18.6934 12.1072 19.6429 12.656C21.0682 13.4797 22.088 14.8099 22.5141 16.4014C22.876 17.7533 22.7708 19.1561 22.2266 20.4227C22.9213 20.2772 23.6198 20.1718 24.3188 20.1051C24.6895 18.7477 24.6976 17.311 24.3239 15.9157C23.7685 13.8404 22.4387 12.1057 20.5799 11.0314C18.721 9.95714 16.5549 9.67186 14.4821 10.2279C12.4086 10.7838 10.6757 12.1149 9.60236 13.9757C8.52932 15.8363 8.24403 18.0041 8.79965 20.0794C9.64113 23.2231 12.2422 25.4338 15.2587 25.9345C15.6867 26.0057 16.123 26.0426 16.5639 26.0426C17.25 26.0426 17.9475 25.9536 18.641 25.7676C18.6413 25.7674 18.6415 25.7674 18.6417 25.7674L22.2991 24.7864C26.5011 23.6598 30.9579 24.447 34.5258 26.9475C34.6893 27.0623 34.8767 27.117 35.0621 27.117C35.3575 27.117 35.6482 26.9777 35.8305 26.7171C36.1273 26.2928 36.0242 25.7079 35.6003 25.4109", fill: "#7259EF" }) }),
  /* @__PURE__ */ t("mask", { id: "mask1_14311_32184", style: { maskType: "alpha" }, maskUnits: "userSpaceOnUse", x: "0", y: "1", width: "34", height: "34", children: /* @__PURE__ */ t("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M0 1.42424H33.1249V34.5758H0V1.42424Z", fill: "white" }) }),
  /* @__PURE__ */ t("g", { mask: "url(#mask1_14311_32184)", children: /* @__PURE__ */ t("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M24.0186 31.2113L20.3613 32.1923C16.5742 33.2079 12.6174 32.6868 9.22128 30.7242C5.8253 28.7615 3.3961 25.5924 2.38113 21.8011C1.3663 18.0094 1.88707 14.0494 3.84777 10.6499C5.80846 7.25045 8.97432 4.81892 12.7623 3.80293C20.5814 1.70635 28.6476 6.3673 30.7425 14.194C31.3178 16.3436 31.4007 18.5368 31.0038 20.667C31.6113 20.8303 32.2116 21.0237 32.8022 21.2478C33.3022 18.7706 33.2229 16.2129 32.5525 13.7085C30.1901 4.88281 21.0952 -0.374998 12.2772 1.9912C8.0061 3.13683 4.4359 5.87862 2.22506 9.71203C0.0140629 13.5451 -0.573202 18.0111 0.57113 22.2863C1.71561 26.562 4.45492 30.1355 8.28441 32.3485C10.8354 33.823 13.6662 34.5759 16.5349 34.5758C17.9726 34.5758 19.4204 34.3865 20.8465 34.0041L24.5038 33.023C26.4879 32.4911 28.5997 32.9809 30.1513 34.3339C30.5415 34.6739 31.1332 34.6336 31.4733 34.2429C31.8132 33.8522 31.7724 33.2598 31.3823 32.9197C29.359 31.1557 26.6061 30.5168 24.0186 31.2113", fill: "#7259EF" }) }),
  /* @__PURE__ */ t("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M34.5299 29.8732L33.4595 29.1229C33.4583 29.122 33.4567 29.1214 33.4556 29.1205C33.3009 29.0051 33.1428 28.8962 32.9841 28.7887C32.9076 28.737 32.8308 28.6862 32.7534 28.6362C32.6453 28.5664 32.536 28.4986 32.4259 28.4324C32.3281 28.3736 32.2301 28.3157 32.131 28.2599C32.0422 28.2097 31.9526 28.161 31.8628 28.1131C31.7401 28.0478 31.6167 27.9836 31.4921 27.9226C31.4263 27.8904 31.36 27.8593 31.2936 27.8283C31.1442 27.7584 30.9941 27.6903 30.8423 27.6268C30.801 27.6093 30.7594 27.5928 30.718 27.5759C30.5417 27.5044 30.3646 27.4356 30.1859 27.3724C30.1689 27.3664 30.1518 27.3608 30.1349 27.3548C28.4685 26.7719 26.6951 26.5544 24.9204 26.7291C24.8813 26.733 24.8423 26.7393 24.8032 26.7433C24.6215 26.7628 24.4401 26.7841 24.2589 26.8117C24.1342 26.8307 24.0099 26.8557 23.8855 26.8786C23.7883 26.8965 23.6907 26.9114 23.5936 26.9316C23.3674 26.979 23.1415 27.0327 22.9161 27.0931L19.2588 28.0739C13.7099 29.5626 7.98261 26.2535 6.49536 20.6973C5.0081 15.1415 8.31377 9.41021 13.8646 7.92121C19.4153 6.43294 25.1411 9.74152 26.6283 15.2974C27.047 16.8626 27.0932 18.4782 26.7837 20.0322C27.4122 20.0547 28.0382 20.1095 28.6597 20.1944C28.9813 18.4236 28.9141 16.5902 28.4382 14.8122C26.6838 8.25702 19.9273 4.35305 13.3795 6.10947C6.83073 7.8659 2.93068 14.6279 4.68551 21.1831C6.44004 27.7381 13.1957 31.6415 19.7442 29.8857L23.4015 28.9047C26.5139 28.0704 29.7792 28.703 32.3596 30.6413C32.3642 30.6447 32.3691 30.6469 32.3737 30.65C32.3776 30.653 32.3805 30.6566 32.3845 30.6595L33.455 31.4098C33.6184 31.5243 33.806 31.5794 33.9916 31.5794C34.2869 31.5794 34.5777 31.44 34.7599 31.1795C35.0568 30.7552 34.9536 30.1704 34.5299 29.8732", fill: "#7259EF" })
] })), V2 = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: d ? "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM169.8 165.3l.4-1.2c1.1-3.2 4.1-5.3 7.5-5.3l58.3 0c8.3 0 15.1 6.7 15.1 15.1c0 5.4-2.9 10.4-7.6 13.1l-44.3 25.4c-7.5 4.3-12.1 12.2-12.1 20.8l0 13.5c0 13.3 10.7 24 24 24c13.1 0 23.8-10.6 24-23.6l32.3-18.5c19.6-11.3 31.7-32.2 31.7-54.8c0-34.8-28.2-63.1-63.1-63.1l-58.3 0c-23.7 0-44.9 15-52.8 37.3l-.4 1.2c-4.4 12.4 2.1 26.2 14.6 30.6s26.2-2.1 30.6-14.6zM256 320a32 32 0 1 1 0 64 32 32 0 1 1 0-64z" : "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm169.8-90.7c7.9-22.3 29.1-37.3 52.8-37.3l58.3 0c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24l0-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1l-58.3 0c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
        }
      )
    })
  );
}), H2 = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M256 464c7.4 0 27-7.2 47.6-48.4c8.8-17.7 16.4-39.2 22-63.6l-139.2 0c5.6 24.4 13.2 45.9 22 63.6C229 456.8 248.6 464 256 464zM178.5 304l155 0c1.6-15.3 2.5-31.4 2.5-48s-.9-32.7-2.5-48l-155 0c-1.6 15.3-2.5 31.4-2.5 48s.9 32.7 2.5 48zm7.9-144l139.2 0c-5.6-24.4-13.2-45.9-22-63.6C283 55.2 263.4 48 256 48s-27 7.2-47.6 48.4c-8.8 17.7-16.4 39.2-22 63.6zm195.3 48c1.5 15.5 2.2 31.6 2.2 48s-.8 32.5-2.2 48l76.7 0c3.6-15.4 5.6-31.5 5.6-48s-1.9-32.6-5.6-48l-76.7 0zm58.8-48c-21.4-41.1-56.1-74.1-98.4-93.4c14.1 25.6 25.3 57.5 32.6 93.4l65.9 0zm-303.3 0c7.3-35.9 18.5-67.7 32.6-93.4c-42.3 19.3-77 52.3-98.4 93.4l65.9 0zM53.6 208c-3.6 15.4-5.6 31.5-5.6 48s1.9 32.6 5.6 48l76.7 0c-1.5-15.5-2.2-31.6-2.2-48s.8-32.5 2.2-48l-76.7 0zM342.1 445.4c42.3-19.3 77-52.3 98.4-93.4l-65.9 0c-7.3 35.9-18.5 67.7-32.6 93.4zm-172.2 0c-14.1-25.6-25.3-57.5-32.6-93.4l-65.9 0c21.4 41.1 56.1 74.1 98.4 93.4zM256 512A256 256 0 1 1 256 0a256 256 0 1 1 0 512z"
        }
      )
    })
  );
}), S2 = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M8.20994 15.7721L8.92462 15.0932C9.10329 14.9145 9.10329 14.6286 8.92462 14.4857L3.38582 8.94689L15.5712 8.94689C15.8213 8.94689 16 8.73248 16 8.51808L16 7.51752C16 7.26738 15.8213 7.08871 15.5712 7.08871L3.38582 7.08871L8.92462 1.51417C9.1033 1.37123 9.1033 1.08536 8.92462 0.906685L8.20994 0.227735C8.067 0.0490638 7.78113 0.0490638 7.60246 0.227735L0.134003 7.69619C-0.0446682 7.87486 -0.0446683 8.125 0.134003 8.30367L7.60246 15.7721C7.78113 15.9508 8.067 15.9508 8.20994 15.7721Z"
        }
      )
    })
  );
}), N2 = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 448 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M248 72c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 160L40 232c-13.3 0-24 10.7-24 24s10.7 24 24 24l160 0 0 160c0 13.3 10.7 24 24 24s24-10.7 24-24l0-160 160 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-160 0 0-160z"
        }
      )
    })
  );
}), k2 = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 576 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M303.5 5.7c-9-7.6-22.1-7.6-31.1 0l-264 224c-10.1 8.6-11.3 23.7-2.8 33.8s23.7 11.3 33.8 2.8L64 245.5V432c0 44.2 35.8 80 80 80H432c44.2 0 80-35.8 80-80V245.5l24.5 20.8c10.1 8.6 25.2 7.3 33.8-2.8s7.3-25.2-2.8-33.8l-264-224zM464 204.8V432c0 17.7-14.3 32-32 32H144c-17.7 0-32-14.3-32-32V204.8L288 55.5 464 204.8z"
        }
      )
    })
  );
}), T2 = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M406.5 399.6C387.4 352.9 341.5 320 288 320H224c-53.5 0-99.4 32.9-118.5 79.6C69.9 362.2 48 311.7 48 256C48 141.1 141.1 48 256 48s208 93.1 208 208c0 55.7-21.9 106.2-57.5 143.6zm-40.1 32.7C334.4 452.4 296.6 464 256 464s-78.4-11.6-110.5-31.7c7.3-36.7 39.7-64.3 78.5-64.3h64c38.8 0 71.2 27.6 78.5 64.3zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-272a40 40 0 1 1 0-80 40 40 0 1 1 0 80zm-88-40a88 88 0 1 0 176 0 88 88 0 1 0 -176 0z"
        }
      )
    })
  );
}), P2 = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M255.4 48.2c.2-.1 .4-.2 .6-.2s.4 .1 .6 .2L460.6 194c2.1 1.5 3.4 3.9 3.4 6.5v13.6L291.5 355.7c-20.7 17-50.4 17-71.1 0L48 214.1V200.5c0-2.6 1.2-5 3.4-6.5L255.4 48.2zM48 276.2L190 392.8c38.4 31.5 93.7 31.5 132 0L464 276.2V456c0 4.4-3.6 8-8 8H56c-4.4 0-8-3.6-8-8V276.2zM256 0c-10.2 0-20.2 3.2-28.5 9.1L23.5 154.9C8.7 165.4 0 182.4 0 200.5V456c0 30.9 25.1 56 56 56H456c30.9 0 56-25.1 56-56V200.5c0-18.1-8.7-35.1-23.5-45.6L284.5 9.1C276.2 3.2 266.2 0 256 0z"
        }
      )
    })
  );
}), U2 = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 384 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M384 192c0 87.4-117 243-168.3 307.2c-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192C0 86 86 0 192 0S384 86 384 192zM192 48c-79.5 0-144 64.5-144 144c0 66.5 90.8 195.2 142.3 250.9c3.5 3.8 9.9 3.8 13.4 0C255.2 387.2 346 258.5 346 192c0-79.5-64.5-144-144-144zm0 240a96 96 0 1 0 0-192 96 96 0 1 0 0 192zm0-144a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
        }
      )
    })
  );
}), b2 = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M0 96C0 60.7 28.7 32 64 32H196.1c19.1 0 37.4 7.6 50.9 21.1L289.9 96H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H448c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16H286.6c-10.6 0-20.8-4.2-28.3-11.7L213.1 87c-4.5-4.5-10.6-7-17-7H64z"
        }
      )
    })
  );
}), E2 = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M123.6 391.3c12.9-9.4 29.6-11.8 44.6-6.4c26.5 9.6 56.2 15.1 87.8 15.1c124.7 0 208-80.5 208-160s-83.3-160-208-160S48 160.5 48 240c0 32 12.4 62.8 35.7 89.2c8.6 9.7 12.8 22.5 11.8 35.5c-1.4 18.1-5.7 34.7-11.3 49.4c17-7.9 31.1-16.7 39.4-22.7zM21.2 431.9c1.8-2.7 3.5-5.4 5.1-8.1c10-16.6 19.5-38.4 21.4-62.9C17.7 326.8 0 285.1 0 240C0 125.1 114.6 32 256 32s256 93.1 256 208s-114.6 208-256 208c-37.1 0-72.3-6.4-104.1-17.9c-11.9 8.7-31.3 20.6-54.3 30.6c-15.1 6.6-32.3 12.6-50.1 16.1c-.8 .2-1.6 .3-2.4 .5c-4.4 .8-8.7 1.5-13.2 1.9c-.2 0-.5 .1-.7 .1c-5.1 .5-10.2 .8-15.3 .8c-6.5 0-12.3-3.9-14.8-9.9c-2.5-6-1.1-12.8 3.4-17.4c4.1-4.2 7.8-8.7 11.3-13.5c1.7-2.3 3.3-4.6 4.8-6.9c.1-.2 .2-.3 .3-.5z"
        }
      )
    })
  );
}), Z2 = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 384 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M320 464c8.8 0 16-7.2 16-16V160H256c-17.7 0-32-14.3-32-32V48H64c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16H320zM0 64C0 28.7 28.7 0 64 0H229.5c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64z"
        }
      )
    })
  );
}), G2 = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M64 112c-8.8 0-16 7.2-16 16v22.1L220.5 291.7c20.7 17 50.4 17 71.1 0L464 150.1V128c0-8.8-7.2-16-16-16H64zM48 212.2V384c0 8.8 7.2 16 16 16H448c8.8 0 16-7.2 16-16V212.2L322 328.8c-38.4 31.5-93.7 31.5-132 0L48 212.2zM0 128C0 92.7 28.7 64 64 64H448c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128z"
        }
      )
    })
  );
}), D2 = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 384 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M24 0C10.7 0 0 10.7 0 24V488c0 13.3 10.7 24 24 24H360c13.3 0 24-10.7 24-24V24c0-13.3-10.7-24-24-24H24zM48 48H336V464H48V48zm64 64v48H272V112H112zm0 96v48H272V208H112zm0 96v48H272V304H112z"
        }
      )
    })
  );
}), _2 = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: d ? "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z" : "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L369 209z"
        }
      )
    })
  );
}), q2 = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 384 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M320 464c8.8 0 16-7.2 16-16l0-288-80 0c-17.7 0-32-14.3-32-32l0-80L64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16l256 0zM0 64C0 28.7 28.7 0 64 0L229.5 0c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3L384 448c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64z"
        }
      )
    })
  );
}), O2 = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M2.6011 5.42559L7.88652 0.125886C8.05437 -0.0419619 8.32578 -0.0419619 8.49363 0.125886L13.779 5.42559C13.9469 5.59344 13.9469 5.86485 13.779 6.0327L13.0791 6.73266C12.9077 6.90408 12.6327 6.90051 12.4684 6.72552L9.11859 3.25785V12.1431C9.11859 12.3788 8.92575 12.5716 8.69004 12.5716H7.6901C7.4544 12.5716 7.26155 12.3788 7.26155 12.1431V3.25785L3.91531 6.72552C3.74746 6.89694 3.47248 6.90051 3.30463 6.73266L2.60467 6.0327C2.43325 5.86485 2.43325 5.59344 2.6011 5.42559ZM14.6183 14.143H1.76186C1.52616 14.143 1.33331 14.3358 1.33331 14.5715V15.5715C1.33331 15.8072 1.52616 16 1.76186 16H14.6183C14.854 16 15.0468 15.8072 15.0468 15.5715V14.5715C15.0468 14.3358 14.854 14.143 14.6183 14.143Z"
        }
      )
    })
  );
}), Q2 = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 320 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z"
        }
      )
    })
  );
}), j2 = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 320 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: d ? "M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5-45.3 0l-192 192z" : "M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"
        }
      )
    })
  );
}), W2 = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 448 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M440.6 273.4c4.7-4.5 7.4-10.8 7.4-17.4s-2.7-12.8-7.4-17.4l-176-168c-9.6-9.2-24.8-8.8-33.9 .8s-8.8 24.8 .8 33.9L364.1 232 24 232c-13.3 0-24 10.7-24 24s10.7 24 24 24l340.1 0L231.4 406.6c-9.6 9.2-9.9 24.3-.8 33.9s24.3 9.9 33.9 .8l176-168z"
        }
      )
    })
  );
}), X2 = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M352 144a96 96 0 1 0 -192 0 96 96 0 1 0 192 0zm-240 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zM49.3 464l413.4 0c-8.3-54.4-55.3-96-112-96l-189.4 0c-56.7 0-103.6 41.6-112 96zM0 481.3C0 392.2 72.2 320 161.3 320l189.4 0C439.8 320 512 392.2 512 481.3c0 17-13.8 30.7-30.7 30.7L30.7 512C13.8 512 0 498.2 0 481.3z"
        }
      )
    })
  );
}), J2 = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 576 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M549.7 124.1c-6.3-23.7-24.8-42.3-48.3-48.6C458.8 64 288 64 288 64S117.2 64 74.6 75.5c-23.5 6.3-42 24.9-48.3 48.6-11.4 42.9-11.4 132.3-11.4 132.3s0 89.4 11.4 132.3c6.3 23.6 24.8 41.5 48.3 47.8C117.2 448 288 448 288 448s170.8 0 213.4-11.5c23.5-6.3 42-24.2 48.3-47.8 11.4-42.9 11.4-132.3 11.4-132.3s0-89.4-11.4-132.3zm-317.5 213.5V175.2l142.7 81.2-142.7 81.2z"
        }
      )
    })
  );
}), K2 = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 384 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: d ? "M73 39c-14.8-9-33.4-9.4-48.5-.9S0 62.6 0 80v352c0 17.4 9.4 33.4 24.5 41.9s33.7 8.1 48.5-.9L361 297c14.3-8.7 23-24.2 23-41s-8.7-32.2-23-41L73 39z" : "M48 432L336 256 48 80l0 352zM24.5 38.1C39.7 29.6 58.2 30 73 39L361 215c14.3 8.7 23 24.2 23 41s-8.7 32.2-23 41L73 473c-14.8 9.1-33.4 9.4-48.5 .9S0 449.4 0 432L0 80C0 62.6 9.4 46.6 24.5 38.1z"
        }
      )
    })
  );
}), Y2 = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: d ? "M313.4 32.9c26 5.2 42.9 30.5 37.7 56.5l-2.3 11.4c-5.3 26.7-15.1 52.1-28.8 75.2H464c26.5 0 48 21.5 48 48c0 18.5-10.5 34.6-25.9 42.6C497 275.4 504 288.9 504 304c0 23.4-16.8 42.9-38.9 47.1c4.4 7.3 6.9 15.8 6.9 24.9c0 21.3-13.9 39.4-33.1 45.6c.7 3.3 1.1 6.8 1.1 10.4c0 26.5-21.5 48-48 48H294.5c-19 0-37.5-5.6-53.3-16.1l-38.5-25.7C176 420.4 160 390.4 160 358.3V320 272 247.1c0-29.2 13.3-56.7 36-75l7.4-5.9c26.5-21.2 44.6-51 51.2-84.2l2.3-11.4c5.2-26 30.5-42.9 56.5-37.7zM32 192H96c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V224c0-17.7 14.3-32 32-32z" : "M96 191.1H32c-17.67 0-32 14.33-32 32v192c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V223.1C128 206.3 113.7 191.1 96 191.1zM512 227c0-36.89-30.05-66.92-66.97-66.92h-99.86C354.7 135.1 360 113.5 360 100.8c0-33.8-26.2-68.78-70.06-68.78c-46.61 0-59.36 32.44-69.61 58.5c-31.66 80.5-60.33 66.39-60.33 93.47c0 12.84 10.36 23.99 24.02 23.99c5.256 0 10.55-1.721 14.97-5.26c76.76-61.37 57.97-122.7 90.95-122.7c16.08 0 22.06 12.75 22.06 20.79c0 7.404-7.594 39.55-25.55 71.59c-2.046 3.646-3.066 7.686-3.066 11.72c0 13.92 11.43 23.1 24 23.1h137.6C455.5 208.1 464 216.6 464 227c0 9.809-7.766 18.03-17.67 18.71c-12.66 .8593-22.36 11.4-22.36 23.94c0 15.47 11.39 15.95 11.39 28.91c0 25.37-35.03 12.34-35.03 42.15c0 11.22 6.392 13.03 6.392 22.25c0 22.66-29.77 13.76-29.77 40.64c0 4.515 1.11 5.961 1.11 9.456c0 10.45-8.516 18.95-18.97 18.95h-52.53c-25.62 0-51.02-8.466-71.5-23.81l-36.66-27.51c-4.315-3.245-9.37-4.811-14.38-4.811c-13.85 0-24.03 11.38-24.03 24.04c0 7.287 3.312 14.42 9.596 19.13l36.67 27.52C235 468.1 270.6 480 306.6 480h52.53c35.33 0 64.36-27.49 66.8-62.2c17.77-12.23 28.83-32.51 28.83-54.83c0-3.046-.2187-6.107-.6406-9.122c17.84-12.15 29.28-32.58 29.28-55.28c0-5.311-.6406-10.54-1.875-15.64C499.9 270.1 512 250.2 512 227z"
        }
      )
    })
  );
}), $2 = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({
        width: o(l),
        height: o(l)
      }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M323.8 477.2c-38.2 10.9-78.1-11.2-89-49.4l-5.7-20c-3.7-13-10.4-25-19.5-35l-51.3-56.4c-8.9-9.8-8.2-25 1.6-33.9s25-8.2 33.9 1.6l51.3 56.4c14.1 15.5 24.4 34 30.1 54.1l5.7 20c3.6 12.7 16.9 20.1 29.7 16.5s20.1-16.9 16.5-29.7l-5.7-20c-5.7-19.9-14.7-38.7-26.6-55.5c-5.2-7.3-5.8-16.9-1.7-24.9s12.3-13 21.3-13L448 288c8.8 0 16-7.2 16-16c0-6.8-4.3-12.7-10.4-15c-7.4-2.8-13-9-14.9-16.7s.1-15.8 5.3-21.7c2.5-2.8 4-6.5 4-10.6c0-7.8-5.6-14.3-13-15.7c-8.2-1.6-15.1-7.3-18-15.2s-1.6-16.7 3.6-23.3c2.1-2.7 3.4-6.1 3.4-9.9c0-6.7-4.2-12.6-10.2-14.9c-11.5-4.5-17.7-16.9-14.4-28.8c.4-1.3 .6-2.8 .6-4.3c0-8.8-7.2-16-16-16l-97.5 0c-12.6 0-25 3.7-35.5 10.7l-61.7 41.1c-11 7.4-25.9 4.4-33.3-6.7s-4.4-25.9 6.7-33.3l61.7-41.1c18.4-12.3 40-18.8 62.1-18.8L384 32c34.7 0 62.9 27.6 64 62c14.6 11.7 24 29.7 24 50c0 4.5-.5 8.8-1.3 13c15.4 11.7 25.3 30.2 25.3 51c0 6.5-1 12.8-2.8 18.7C504.8 238.3 512 254.3 512 272c0 35.3-28.6 64-64 64l-92.3 0c4.7 10.4 8.7 21.2 11.8 32.2l5.7 20c10.9 38.2-11.2 78.1-49.4 89zM32 384c-17.7 0-32-14.3-32-32L0 128c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l0 224c0 17.7-14.3 32-32 32l-64 0z"
        }
      )
    })
  );
}), l1 = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M288 240l-96 0c-66.2 0-122 44.7-138.8 105.5C49.9 333.1 48 319.3 48 304c0-70.7 57.3-128 128-128l112 0 24 0c13.3 0 24-10.7 24-24l0-24 0-28.1L456.1 208 336 316.1l0-28.1 0-24c0-13.3-10.7-24-24-24l-24 0zm0 48l0 48 0 16c0 12.6 7.4 24.1 19 29.2s25 3 34.4-5.4l160-144c6.7-6.1 10.6-14.7 10.6-23.8s-3.8-17.7-10.6-23.8l-160-144c-9.4-8.5-22.9-10.6-34.4-5.4s-19 16.6-19 29.2l0 16 0 48-48 0-64 0C78.8 128 0 206.8 0 304c0 78 38.6 126.2 68.7 152.1c4.1 3.5 8.1 6.6 11.7 9.3c3.2 2.4 6.2 4.4 8.9 6.2c4.5 3 8.3 5.1 10.8 6.5c2.5 1.4 5.3 1.9 8.1 1.9c10.9 0 19.7-8.9 19.7-19.7c0-6.8-3.6-13.2-8.3-18.1c-.5-.5-.9-.9-1.4-1.4c-2.4-2.3-5.1-5.1-7.7-8.6c-1.7-2.3-3.4-5-5-7.9c-5.3-9.7-9.5-22.9-9.5-40.2c0-53 43-96 96-96l48 0 48 0z"
        }
      )
    })
  );
}), c1 = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z"
        }
      )
    })
  );
}), r1 = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M400 32H48A48 48 0 0 0 0 80v352a48 48 0 0 0 48 48h137.25V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.27c-30.81 0-40.42 19.12-40.42 38.73V256h68.78l-11 71.69h-57.78V480H400a48 48 0 0 0 48-48V80a48 48 0 0 0-48-48z"
        }
      )
    })
  );
}), e1 = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 448 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M416 32H31.9C14.3 32 0 46.5 0 64.3v383.4C0 465.5 14.3 480 31.9 480H416c17.6 0 32-14.5 32-32.3V64.3c0-17.8-14.4-32.3-32-32.3zM135.4 416H69V202.2h66.5V416zm-33.2-243c-21.3 0-38.5-17.3-38.5-38.5S80.9 96 102.2 96c21.2 0 38.5 17.3 38.5 38.5 0 21.3-17.2 38.5-38.5 38.5zm282.1 243h-66.4V312c0-24.8-.5-56.7-34.5-56.7-34.6 0-39.9 27-39.9 54.9V416h-66.4V202.2h63.7v29.2h.9c8.9-16.8 30.6-34.5 62.9-34.5 67.2 0 79.7 44.3 79.7 101.9V416z"
        }
      )
    })
  );
}), t1 = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 448 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"
        }
      )
    })
  );
}), s1 = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 448 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M177.1 48l93.7 0c2.7 0 5.2 1.3 6.7 3.6l19 28.4-145 0 19-28.4c1.5-2.2 4-3.6 6.7-3.6zM354.2 80L317.5 24.9C307.1 9.4 289.6 0 270.9 0L177.1 0c-18.7 0-36.2 9.4-46.6 24.9L93.8 80 80.1 80 32 80l-8 0C10.7 80 0 90.7 0 104s10.7 24 24 24l11.6 0L59.6 452.7c2.5 33.4 30.3 59.3 63.8 59.3l201.1 0c33.5 0 61.3-25.9 63.8-59.3L412.4 128l11.6 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0-48.1 0-13.7 0zm10.1 48L340.5 449.2c-.6 8.4-7.6 14.8-16 14.8l-201.1 0c-8.4 0-15.3-6.5-16-14.8L83.7 128l280.6 0z"
        }
      )
    })
  );
}), o1 = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 448 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M152 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L64 64C28.7 64 0 92.7 0 128l0 16 0 48L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-256 0-48 0-16c0-35.3-28.7-64-64-64l-40 0 0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40L152 64l0-40zM48 192l352 0 0 256c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-256z"
        }
      )
    })
  );
}), i1 = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: d ? "M47.6 300.4L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9L464.4 300.4c30.4-28.3 47.6-68 47.6-109.5v-5.8c0-69.9-50.5-129.5-119.4-141C347 36.5 300.6 51.4 268 84L256 96 244 84c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5z" : "M225.8 468.2l-2.5-2.3L48.1 303.2C17.4 274.7 0 234.7 0 192.8v-3.3c0-70.4 50-130.8 119.2-144C158.6 37.9 198.9 47 231 69.6c9 6.4 17.4 13.8 25 22.3c4.2-4.8 8.7-9.2 13.5-13.3c3.7-3.2 7.5-6.2 11.5-9c0 0 0 0 0 0C313.1 47 353.4 37.9 392.8 45.4C462 58.6 512 119.1 512 189.5v3.3c0 41.9-17.4 81.9-48.1 110.4L288.7 465.9l-2.5 2.3c-8.2 7.6-19 11.9-30.2 11.9s-22-4.2-30.2-11.9zM239.1 145c-.4-.3-.7-.7-1-1.1l-17.8-20c0 0-.1-.1-.1-.1c0 0 0 0 0 0c-23.1-25.9-58-37.7-92-31.2C81.6 101.5 48 142.1 48 189.5v3.3c0 28.5 11.9 55.8 32.8 75.2L256 430.7 431.2 268c20.9-19.4 32.8-46.7 32.8-75.2v-3.3c0-47.3-33.6-88-80.1-96.9c-34-6.5-69 5.4-92 31.2c0 0 0 0-.1 .1s0 0-.1 .1l-17.8 20c-.3 .4-.7 .7-1 1.1c-4.5 4.5-10.6 7-16.9 7s-12.4-2.5-16.9-7z"
        }
      )
    })
  );
}), a1 = f.forwardRef((h, a) => {
  var w = h, { ariaHidden: r = "true", color: e, size: d = 16, style: l } = w, i = g(w, ["ariaHidden", "color", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 448 512",
      "aria-hidden": r,
      color: e,
      ref: a,
      role: "img",
      style: s({ width: o(d), height: o(d) }, l)
    }, i), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M331.5 235.7c2.2 .9 4.2 1.9 6.3 2.8c29.2 14.1 50.6 35.2 61.8 61.4c15.7 36.5 17.2 95.8-30.3 143.2c-36.2 36.2-80.3 52.5-142.6 53h-.3c-70.2-.5-124.1-24.1-160.4-70.2c-32.3-41-48.9-98.1-49.5-169.6V256v-.2C17 184.3 33.6 127.2 65.9 86.2C102.2 40.1 156.2 16.5 226.4 16h.3c70.3 .5 124.9 24 162.3 69.9c18.4 22.7 32 50 40.6 81.7l-40.4 10.8c-7.1-25.8-17.8-47.8-32.2-65.4c-29.2-35.8-73-54.2-130.5-54.6c-57 .5-100.1 18.8-128.2 54.4C72.1 146.1 58.5 194.3 58 256c.5 61.7 14.1 109.9 40.3 143.3c28 35.6 71.2 53.9 128.2 54.4c51.4-.4 85.4-12.6 113.7-40.9c32.3-32.2 31.7-71.8 21.4-95.9c-6.1-14.2-17.1-26-31.9-34.9c-3.7 26.9-11.8 48.3-24.7 64.8c-17.1 21.8-41.4 33.6-72.7 35.3c-23.6 1.3-46.3-4.4-63.9-16c-20.8-13.8-33-34.8-34.3-59.3c-2.5-48.3 35.7-83 95.2-86.4c21.1-1.2 40.9-.3 59.2 2.8c-2.4-14.8-7.3-26.6-14.6-35.2c-10-11.7-25.6-17.7-46.2-17.8H227c-16.6 0-39 4.6-53.3 26.3l-34.4-23.6c19.2-29.1 50.3-45.1 87.8-45.1h.8c62.6 .4 99.9 39.5 103.7 107.7l-.2 .2zm-156 68.8c1.3 25.1 28.4 36.8 54.6 35.3c25.6-1.4 54.6-11.4 59.5-73.2c-13.2-2.9-27.8-4.4-43.4-4.4c-4.8 0-9.6 .1-14.4 .4c-42.9 2.4-57.2 23.2-56.2 41.8l-.1 .1z"
        }
      )
    })
  );
}), h1 = f.forwardRef((h, a) => {
  var w = h, { ariaHidden: r = "true", color: e, size: d = 16, style: l } = w, i = g(w, ["ariaHidden", "color", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512",
      "aria-hidden": r,
      color: e,
      ref: a,
      role: "img",
      style: s({ width: o(d), height: o(d) }, l)
    }, i), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M111.8 62.2C170.2 105.9 233 194.7 256 242.4c23-47.6 85.8-136.4 144.2-180.2c42.1-31.6 110.3-56 110.3 21.8c0 15.5-8.9 130.5-14.1 149.2C478.2 298 412 314.6 353.1 304.5c102.9 17.5 129.1 75.5 72.5 133.5c-107.4 110.2-154.3-27.6-166.3-62.9l0 0c-1.7-4.9-2.6-7.8-3.3-7.8s-1.6 3-3.3 7.8l0 0c-12 35.3-59 173.1-166.3 62.9c-56.5-58-30.4-116 72.5-133.5C100 314.6 33.8 298 15.7 233.1C10.4 214.4 1.5 99.4 1.5 83.9c0-77.8 68.2-53.4 110.3-21.8z"
        }
      )
    })
  );
}), d1 = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 14 13",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M12.5547 1.83594C13.1406 2.42188 13.1406 3.35938 12.5547 3.94531L10.7969 5.70312L10 6.5L4.28125 12.2188L1.60938 12.5C1.58594 12.5 1.5625 12.5 1.53906 12.5C1.21094 12.5 0.953125 12.2188 1 11.8906L1.28125 9.21875L7 3.5L7.79688 2.70312L9.55469 0.945312C9.83594 0.664062 10.2344 0.5 10.6094 0.5C10.9844 0.5 11.3828 0.664062 11.6641 0.945312L11.6641 0.945312L12.5547 1.83594ZM3.76562 11.1406L9.20312 5.72656L9.92969 5L8.5 3.57031L7.77344 4.29688L2.35938 9.73438L2.19531 11.3047L3.76562 11.1406ZM11.7578 3.14844C11.8984 3.00781 11.8984 2.77344 11.7578 2.63281L10.8672 1.74219C10.7734 1.64844 10.6562 1.625 10.6094 1.625C10.5625 1.625 10.4453 1.64844 10.3516 1.74219L9.29688 2.77344L10.7266 4.20312L11.7578 3.14844Z"
        }
      )
    })
  );
}), w1 = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 448 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M384 336l-192 0c-8.8 0-16-7.2-16-16l0-256c0-8.8 7.2-16 16-16l140.1 0L400 115.9 400 320c0 8.8-7.2 16-16 16zM192 384l192 0c35.3 0 64-28.7 64-64l0-204.1c0-12.7-5.1-24.9-14.1-33.9L366.1 14.1c-9-9-21.2-14.1-33.9-14.1L192 0c-35.3 0-64 28.7-64 64l0 256c0 35.3 28.7 64 64 64zM64 128c-35.3 0-64 28.7-64 64L0 448c0 35.3 28.7 64 64 64l192 0c35.3 0 64-28.7 64-64l0-32-48 0 0 32c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-256c0-8.8 7.2-16 16-16l32 0 0-48-32 0z"
        }
      )
    })
  );
}), n1 = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 384 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M360 480c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 432c-13.3 0-24 10.7-24 24s10.7 24 24 24l336 0zM174.5 344.4c4.5 4.8 10.9 7.6 17.5 7.6s12.9-2.7 17.5-7.6l128-136c9.1-9.7 8.6-24.8-1-33.9s-24.8-8.6-33.9 1L216 267.5l0-83.5 0-128c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 128 0 83.5L81.5 175.6c-9.1-9.7-24.3-10.1-33.9-1s-10.1 24.3-1 33.9l128 136z"
        }
      )
    })
  );
}), g1 = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 448 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M64 432c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l320 0c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16L64 432zM0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416zM128 288c13.3 0 24-10.7 24-24l0-112c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24zm168 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-176c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 176zm-72-72c13.3 0 24-10.7 24-24l0-80c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 80c0 13.3 10.7 24 24 24z"
        }
      )
    })
  );
}), f1 = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: d ? "M57.6 35.8C23.1 20.6-11.3 57.4 6.1 90.9l63 121.2c4.4 8.4 12.6 14.1 22 15.3c0 0 0 0 0 0L266 249.3c3.4 .4 6 3.3 6 6.7s-2.6 6.3-6 6.7L91.1 284.6s0 0 0 0c-9.4 1.2-17.6 6.9-22 15.3L6.1 421.1c-17.4 33.5 17 70.2 51.6 55.1L492.9 285.3c25.5-11.2 25.5-47.4 0-58.6L57.6 35.8z" : "M133.9 232L65.8 95.9 383.4 232l-249.5 0zm0 48l249.5 0L65.8 416.1l68-136.1zM44.6 34.6C32.3 29.3 17.9 32.3 8.7 42S-2.6 66.3 3.4 78.3L92.2 256 3.4 433.7c-6 12-3.9 26.5 5.3 36.3s23.5 12.7 35.9 7.5l448-192c11.8-5 19.4-16.6 19.4-29.4s-7.6-24.4-19.4-29.4l-448-192z"
        }
      )
    })
  );
}), L1 = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M237.5 508.3c11.8 4.9 25.1 4.9 36.9 0C360.1 472.6 496 349.3 496 128c0-19.4-11.7-36.9-29.5-44.3l-192-80a48.2 48.2 0 0 0 -36.9 0l-192 80C27.7 91.1 16 108.6 16 128c0 198.5 114.5 335.7 221.5 380.3zM256 48l192 80c0 173.8-98.4 297-192 336-97.5-40.6-192-166.7-192-336l192-80z"
        }
      )
    })
  );
}), m1 = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 576 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M527.9 32H48.1C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48.1 48h479.8c26.6 0 48.1-21.5 48.1-48V80c0-26.5-21.5-48-48.1-48zM54.1 80h467.8c3.3 0 6 2.7 6 6v42H48.1V86c0-3.3 2.7-6 6-6zm467.8 352H54.1c-3.3 0-6-2.7-6-6V256h479.8v170c0 3.3-2.7 6-6 6zM192 332v40c0 6.6-5.4 12-12 12h-72c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h72c6.6 0 12 5.4 12 12zm192 0v40c0 6.6-5.4 12-12 12H236c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h136c6.6 0 12 5.4 12 12z"
        }
      )
    })
  );
}), C1 = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 448 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M128 0c13.3 0 24 10.7 24 24l0 40 144 0 0-40c0-13.3 10.7-24 24-24s24 10.7 24 24l0 40 40 0c35.3 0 64 28.7 64 64l0 16 0 48 0 256c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 192l0-48 0-16C0 92.7 28.7 64 64 64l40 0 0-40c0-13.3 10.7-24 24-24zM400 192L48 192l0 256c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-256zM112 256l96 0c8.8 0 16 7.2 16 16l0 96c0 8.8-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16l0-96c0-8.8 7.2-16 16-16z"
        }
      )
    })
  );
}), v1 = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M464 256A208 208 0 1 1 48 256a208 208 0 1 1 416 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM232 120l0 136c0 8 4 15.5 10.7 20l96 64c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L280 243.2 280 120c0-13.3-10.7-24-24-24s-24 10.7-24 24z"
        }
      )
    })
  );
}), M1 = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 128 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M64 368a48 48 0 1 0 0 96 48 48 0 1 0 0-96zm0-160a48 48 0 1 0 0 96 48 48 0 1 0 0-96zM112 96A48 48 0 1 0 16 96a48 48 0 1 0 96 0z"
        }
      )
    })
  );
}), z1 = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 640 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M544 224c44.2 0 80-35.8 80-80s-35.8-80-80-80-80 35.8-80 80 35.8 80 80 80zm0-112c17.6 0 32 14.4 32 32s-14.4 32-32 32-32-14.4-32-32 14.4-32 32-32zM96 224c44.2 0 80-35.8 80-80s-35.8-80-80-80-80 35.8-80 80 35.8 80 80 80zm0-112c17.6 0 32 14.4 32 32s-14.4 32-32 32-32-14.4-32-32 14.4-32 32-32zm396.4 210.9c-27.5-40.8-80.7-56-127.8-41.7-14.2 4.3-29.1 6.7-44.7 6.7s-30.5-2.4-44.7-6.7c-47.1-14.3-100.3 .8-127.8 41.7-12.4 18.4-19.6 40.5-19.6 64.3V432c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48v-44.8c.2-23.8-7-45.9-19.4-64.3zM464 432H176v-44.8c0-36.4 29.2-66.2 65.4-67.2 25.5 10.6 51.9 16 78.6 16 26.7 0 53.1-5.4 78.6-16 36.2 1 65.4 30.7 65.4 67.2V432zm92-176h-24c-17.3 0-33.4 5.3-46.8 14.3 13.4 10.1 25.2 22.2 34.4 36.2 3.9-1.4 8-2.5 12.3-2.5h24c19.8 0 36 16.2 36 36 0 13.2 10.8 24 24 24s24-10.8 24-24c.1-46.3-37.6-84-83.9-84zm-236 0c61.9 0 112-50.1 112-112S381.9 32 320 32 208 82.1 208 144s50.1 112 112 112zm0-176c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zM154.8 270.3c-13.4-9-29.5-14.3-46.8-14.3H84c-46.3 0-84 37.7-84 84 0 13.2 10.8 24 24 24s24-10.8 24-24c0-19.8 16.2-36 36-36h24c4.4 0 8.5 1.1 12.3 2.5 9.3-14 21.1-26.1 34.5-36.2z"
        }
      )
    })
  );
}), p1 = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64V400c0 44.2 35.8 80 80 80H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H80c-8.8 0-16-7.2-16-16V64zm406.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L320 210.7l-57.4-57.4c-12.5-12.5-32.8-12.5-45.3 0l-112 112c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L240 221.3l57.4 57.4c12.5 12.5 32.8 12.5 45.3 0l128-128z"
        }
      )
    })
  );
}), F1 = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M495.9 166.6c3.2 8.7 .5 18.4-6.4 24.6l-43.3 39.4c1.1 8.3 1.7 16.8 1.7 25.4s-.6 17.1-1.7 25.4l43.3 39.4c6.9 6.2 9.6 15.9 6.4 24.6c-4.4 11.9-9.7 23.3-15.8 34.3l-4.7 8.1c-6.6 11-14 21.4-22.1 31.2c-5.9 7.2-15.7 9.6-24.5 6.8l-55.7-17.7c-13.4 10.3-28.2 18.9-44 25.4l-12.5 57.1c-2 9.1-9 16.3-18.2 17.8c-13.8 2.3-28 3.5-42.5 3.5s-28.7-1.2-42.5-3.5c-9.2-1.5-16.2-8.7-18.2-17.8l-12.5-57.1c-15.8-6.5-30.6-15.1-44-25.4L83.1 425.9c-8.8 2.8-18.6 .3-24.5-6.8c-8.1-9.8-15.5-20.2-22.1-31.2l-4.7-8.1c-6.1-11-11.4-22.4-15.8-34.3c-3.2-8.7-.5-18.4 6.4-24.6l43.3-39.4C64.6 273.1 64 264.6 64 256s.6-17.1 1.7-25.4L22.4 191.2c-6.9-6.2-9.6-15.9-6.4-24.6c4.4-11.9 9.7-23.3 15.8-34.3l4.7-8.1c6.6-11 14-21.4 22.1-31.2c5.9-7.2 15.7-9.6 24.5-6.8l55.7 17.7c13.4-10.3 28.2-18.9 44-25.4l12.5-57.1c2-9.1 9-16.3 18.2-17.8C227.3 1.2 241.5 0 256 0s28.7 1.2 42.5 3.5c9.2 1.5 16.2 8.7 18.2 17.8l12.5 57.1c15.8 6.5 30.6 15.1 44 25.4l55.7-17.7c8.8-2.8 18.6-.3 24.5 6.8c8.1 9.8 15.5 20.2 22.1 31.2l4.7 8.1c6.1 11 11.4 22.4 15.8 34.3zM256 336a80 80 0 1 0 0-160 80 80 0 1 0 0 160z"
        }
      )
    })
  );
}), u1 = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M256 0c13.3 0 24 10.7 24 24l0 17.3C380.1 52.4 459.6 131.9 470.7 232l17.3 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-17.3 0C459.6 380.1 380.1 459.6 280 470.7l0 17.3c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-17.3C131.9 459.6 52.4 380.1 41.3 280L24 280c-13.3 0-24-10.7-24-24s10.7-24 24-24l17.3 0C52.4 131.9 131.9 52.4 232 41.3L232 24c0-13.3 10.7-24 24-24zM89.7 280c10.5 73.6 68.7 131.8 142.3 142.3l0-30.3c0-13.3 10.7-24 24-24s24 10.7 24 24l0 30.3c73.6-10.5 131.8-68.7 142.3-142.3L392 280c-13.3 0-24-10.7-24-24s10.7-24 24-24l30.3 0C411.8 158.4 353.6 100.2 280 89.7l0 30.3c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-30.3C158.4 100.2 100.2 158.4 89.7 232l30.3 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-30.3 0zM256 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
        }
      )
    })
  );
}), x1 = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M239 401c9.4 9.4 24.6 9.4 33.9 0L465 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-175 175L81 175c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L239 401z"
        }
      )
    })
  );
}), A1 = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M239 111c9.4-9.4 24.6-9.4 33.9 0L465 303c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-175-175L81 337c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L239 111z"
        }
      )
    })
  );
}), y1 = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 320 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M40 352l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40zm192 0l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40zM40 320c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0zM232 192l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40zM40 160c-22.1 0-40-17.9-40-40L0 72C0 49.9 17.9 32 40 32l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0zM232 32l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40z"
        }
      )
    })
  );
}), I1 = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 384 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M209.4 39.4C204.8 34.7 198.6 32 192 32s-12.8 2.7-17.4 7.4l-168 176c-9.2 9.6-8.8 24.8 .8 33.9s24.8 8.8 33.9-.8L168 115.9 168 456c0 13.3 10.7 24 24 24s24-10.7 24-24l0-340.1L342.6 248.6c9.2 9.6 24.3 9.9 33.9 .8s9.9-24.3 .8-33.9l-168-176z"
        }
      )
    })
  );
}), R1 = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 384 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M174.6 472.6c4.5 4.7 10.8 7.4 17.4 7.4s12.8-2.7 17.4-7.4l168-176c9.2-9.6 8.8-24.8-.8-33.9s-24.8-8.8-33.9 .8L216 396.1 216 56c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 340.1L41.4 263.4c-9.2-9.6-24.3-9.9-33.9-.8s-9.9 24.3-.8 33.9l168 176z"
        }
      )
    })
  );
}), B1 = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M368 208A160 160 0 1 0 48 208a160 160 0 1 0 320 0zM337.1 371.1C301.7 399.2 256.8 416 208 416C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208c0 48.8-16.8 93.7-44.9 129.1L505 471c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L337.1 371.1z"
        }
      )
    })
  );
}), V1 = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 576 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M565.6 36.2C572.1 40.7 576 48.1 576 56V392c0 10-6.2 18.9-15.5 22.4l-168 64c-5.2 2-10.9 2.1-16.1 .3L192 416 37.6 478.7c-5.2 1.8-11 1.7-16.1-.3L5.5 474.4C2.1 473.2 0 470 0 466.4V120c0-10 6.1-18.9 15.5-22.4l168-64c5.2-2 10.9-2.1 16.1-.3L384 96l154.4-62.7c5.2-1.8 11-1.7 16.1 .3l11.1 4.1zM48 402.6l120-42.9V118.6L48 161.4V402.6zM208 359.8l120-42.9V75.8L208 118.6V359.8zM368 316.9l120-42.9V32.9L368 75.8V316.9z"
        }
      )
    })
  );
}), H1 = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 576 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M339.3 367.1c27.3-3.9 51.9-19.4 67.2-42.9L568.2 74.1c12.6-19.5 9.4-45.3-7.6-61.2S517.7-4.4 499.1 9.6L262.4 187.2c-24 18-38.2 46.1-38.4 76.1L339.3 367.1zm-19.6 25.4l-116-104.4C143.9 290.3 96 339.6 96 400c0 3.9 .2 7.8 .6 11.6C98.4 429.1 86.4 448 68.8 448H64c-17.7 0-32 14.3-32 32s14.3 32 32 32H208c61.9 0 112-50.1 112-112c0-2.5-.1-5-.3-7.5z"
        }
      )
    })
  );
}), S1 = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm64 0v64h64V96H64zm384 0H192v64H448V96zM64 224v64h64V224H64zm384 0H192v64H448V224zM64 352v64h64V352H64zm384 0H192v64H448V352z"
        }
      )
    })
  );
}), N1 = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M464 258.2c0 2.7-1 5.2-4.2 8c-3.8 3.1-10.1 5.8-17.8 5.8L344 272c-53 0-96 43-96 96c0 6.8 .7 13.4 2.1 19.8c3.3 15.7 10.2 31.1 14.4 40.6c0 0 0 0 0 0c.7 1.6 1.4 3 1.9 4.3c5 11.5 5.6 15.4 5.6 17.1c0 5.3-1.9 9.5-3.8 11.8c-.9 1.1-1.6 1.6-2 1.8c-.3 .2-.8 .3-1.6 .4c-2.9 .1-5.7 .2-8.6 .2C141.1 464 48 370.9 48 256S141.1 48 256 48s208 93.1 208 208c0 .7 0 1.4 0 2.2zm48 .5c0-.9 0-1.8 0-2.7C512 114.6 397.4 0 256 0S0 114.6 0 256S114.6 512 256 512c3.5 0 7.1-.1 10.6-.2c31.8-1.3 53.4-30.1 53.4-62c0-14.5-6.1-28.3-12.1-42c-4.3-9.8-8.7-19.7-10.8-29.9c-.7-3.2-1-6.5-1-9.9c0-26.5 21.5-48 48-48l97.9 0c36.5 0 69.7-24.8 70.1-61.3zM160 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm0-64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm128-64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm64 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
        }
      )
    })
  );
}), k1 = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 640 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M569.2 59.1L581.1 71c9.4 9.4 9.4 24.6 0 33.9L560 126.1 514.3 80.4l20.8-21.1c9.4-9.5 24.6-9.5 34.1-.1zM359.9 236.8L480.6 114.5 526.1 160 404.6 281.6c-3.3 3.3-7.5 5.6-12 6.5L343 298.5l10.4-49.7c.9-4.5 3.2-8.7 6.4-11.9zM501 25.5L325.7 203.1c-9.7 9.8-16.4 22.3-19.2 35.8l-18 85.7c-1.7 7.9 .8 16.2 6.5 21.9s14 8.2 21.9 6.5l85.5-17.9c13.7-2.9 26.2-9.7 36.1-19.6L615.1 138.9c28.1-28.1 28.1-73.7 0-101.8L603.1 25.2C574.9-3.1 529-2.9 501 25.5zM72 128c-39.8 0-72 32.2-72 72L0 440c0 39.8 32.2 72 72 72l432 0c39.8 0 72-32.2 72-72l0-128c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 128c0 13.3-10.7 24-24 24L72 464c-13.3 0-24-10.7-24-24l0-240c0-13.3 10.7-24 24-24l192 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L72 128zm56 224a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm128-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"
        }
      )
    })
  );
}), T1 = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 384 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M0 64C0 46.3 14.3 32 32 32l48 0 16 0 128 0c70.7 0 128 57.3 128 128c0 31.3-11.3 60.1-30 82.3c37.1 22.4 62 63.1 62 109.7c0 70.7-57.3 128-128 128L96 480l-16 0-48 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l16 0 0-160L48 96 32 96C14.3 96 0 81.7 0 64zM224 224c35.3 0 64-28.7 64-64s-28.7-64-64-64L112 96l0 128 112 0zM112 288l0 128 144 0c35.3 0 64-28.7 64-64s-28.7-64-64-64l-32 0-112 0z"
        }
      )
    })
  );
}), P1 = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 384 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M128 64c0-17.7 14.3-32 32-32l192 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-58.7 0L160 416l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 480c-17.7 0-32-14.3-32-32s14.3-32 32-32l58.7 0L224 96l-64 0c-17.7 0-32-14.3-32-32z"
        }
      )
    })
  );
}), U1 = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M161.3 144c3.2-17.2 14-30.1 33.7-38.6c21.1-9 51.8-12.3 88.6-6.5c11.9 1.9 48.8 9.1 60.1 12c17.1 4.5 34.6-5.6 39.2-22.7s-5.6-34.6-22.7-39.2c-14.3-3.8-53.6-11.4-66.6-13.4c-44.7-7-88.3-4.2-123.7 10.9c-36.5 15.6-64.4 44.8-71.8 87.3c-.1 .6-.2 1.1-.2 1.7c-2.8 23.9 .5 45.6 10.1 64.6c4.5 9 10.2 16.9 16.7 23.9L32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l448 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-209.9 0-.4-.1-1.1-.3c-36-10.8-65.2-19.6-85.2-33.1c-9.3-6.3-15-12.6-18.2-19.1c-3.1-6.1-5.2-14.6-3.8-27.4zM348.9 337.2c2.7 6.5 4.4 15.8 1.9 30.1c-3 17.6-13.8 30.8-33.9 39.4c-21.1 9-51.7 12.3-88.5 6.5c-18-2.9-49.1-13.5-74.4-22.1c-5.6-1.9-11-3.7-15.9-5.4c-16.8-5.6-34.9 3.5-40.5 20.3s3.5 34.9 20.3 40.5c3.6 1.2 7.9 2.7 12.7 4.3c0 0 0 0 0 0s0 0 0 0c24.9 8.5 63.6 21.7 87.6 25.6c0 0 0 0 0 0l.2 0c44.7 7 88.3 4.2 123.7-10.9c36.5-15.6 64.4-44.8 71.8-87.3c3.6-21 2.7-40.4-3.1-58.1l-75.7 0c7 5.6 11.4 11.2 13.9 17.2z"
        }
      )
    })
  );
}), b1 = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 640 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L355.7 253.5 400.2 96 503 96 497 120.2c-4.3 17.1 6.1 34.5 23.3 38.8s34.5-6.1 38.8-23.3l11-44.1C577.6 61.3 554.7 32 523.5 32L376.1 32l-.3 0L204.5 32c-22 0-41.2 15-46.6 36.4l-6.3 25.2L38.8 5.1zm168 131.7c.1-.3 .2-.7 .3-1L217 96l116.7 0L301.3 210.8l-94.5-74.1zM243.3 416L192 416c-17.7 0-32 14.3-32 32s14.3 32 32 32l160 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-42.2 0 17.6-62.1L272.9 311 243.3 416z"
        }
      )
    })
  );
}), E1 = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 576 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M64 96c0-17.7-14.3-32-32-32S0 78.3 0 96L0 256 0 416c0 17.7 14.3 32 32 32s32-14.3 32-32l0-128 192 0 0 128c0 17.7 14.3 32 32 32s32-14.3 32-32l0-160 0-160c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 128L64 224 64 96zm448 0c0-11.1-5.7-21.4-15.2-27.2s-21.2-6.4-31.1-1.4l-64 32c-15.8 7.9-22.2 27.1-14.3 42.9s27.1 22.2 42.9 14.3l17.7-8.8L448 384l-32 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l64 0 64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-32 0 0-288z"
        }
      )
    })
  );
}), Z1 = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 640 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M64 96c0-17.7-14.3-32-32-32S0 78.3 0 96L0 256 0 416c0 17.7 14.3 32 32 32s32-14.3 32-32l0-128 192 0 0 128c0 17.7 14.3 32 32 32s32-14.3 32-32l0-160 0-160c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 128L64 224 64 96zm385.9 47.4c11.6-9.9 26.4-15.4 41.7-15.4l4.5 0c35.3 0 64 28.7 64 64l0 5.8c0 17.9-7.5 35.1-20.8 47.2L378.4 392.4c-9.7 8.9-13 22.9-8.2 35.2S386.8 448 400 448l208 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-125.7 0 100.2-91.9c26.4-24.2 41.5-58.5 41.5-94.4l0-5.8c0-70.7-57.3-128-128-128l-4.5 0c-30.6 0-60.1 10.9-83.3 30.8l-29 24.9c-13.4 11.5-15 31.7-3.5 45.1s31.7 15 45.1 3.5l29-24.9z"
        }
      )
    })
  );
}), G1 = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 640 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M64 96c0-17.7-14.3-32-32-32S0 78.3 0 96L0 256 0 416c0 17.7 14.3 32 32 32s32-14.3 32-32l0-128 192 0 0 128c0 17.7 14.3 32 32 32s32-14.3 32-32l0-160 0-160c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 128L64 224 64 96zM400 64c-17.7 0-32 14.3-32 32s14.3 32 32 32l114.7 0-89.4 89.4c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8l72 0c30.9 0 56 25.1 56 56s-25.1 56-56 56l-64.6 0c-11.7 0-21.7-8.5-23.7-20.1l-.2-1.2c-2.9-17.4-19.4-29.2-36.8-26.3s-29.2 19.4-26.3 36.8l.2 1.2c7.1 42.4 43.8 73.5 86.8 73.5l64.6 0c66.3 0 120-53.7 120-120c0-64.6-51-117.2-114.9-119.9l89.5-89.5c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8L400 64z"
        }
      )
    })
  );
}), D1 = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 640 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M479 103.8L441 256l135 0 0-160c0-17.7 14.3-32 32-32s32 14.3 32 32l0 320c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-96-176 0c-9.9 0-19.2-4.5-25.2-12.3s-8.2-17.9-5.8-27.5l48-192c4.3-17.1 21.7-27.6 38.8-23.3s27.6 21.7 23.3 38.8zM32 64c17.7 0 32 14.3 32 32l0 128 192 0 0-128c0-17.7 14.3-32 32-32s32 14.3 32 32l0 160 0 160c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-128L64 288l0 128c0 17.7-14.3 32-32 32s-32-14.3-32-32L0 256 0 96C0 78.3 14.3 64 32 64z"
        }
      )
    })
  );
}), _1 = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 640 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M64 96c0-17.7-14.3-32-32-32S0 78.3 0 96L0 256 0 416c0 17.7 14.3 32 32 32s32-14.3 32-32l0-128 192 0 0 128c0 17.7 14.3 32 32 32s32-14.3 32-32l0-160 0-160c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 128L64 224 64 96zM432 64c-15.1 0-28.2 10.6-31.3 25.4l-32 152c-2 9.4 .4 19.3 6.5 26.8s15.2 11.8 24.8 11.8l124 0c28.7 0 52 23.3 52 52s-23.3 52-52 52l-67.6 0c-10.3 0-19.5-6.6-22.8-16.4l-3.2-9.7c-5.6-16.8-23.7-25.8-40.5-20.2s-25.8 23.7-20.2 40.5l3.2 9.7c12 35.9 45.6 60.2 83.5 60.2l67.6 0c64.1 0 116-51.9 116-116s-51.9-116-116-116l-84.6 0L458 128l118 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L432 64z"
        }
      )
    })
  );
}), q1 = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 640 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M537 116l-35.3 44.1C578.6 163.1 640 226.4 640 304c0 79.5-64.5 144-144 144s-144-64.5-144-144c0-38.3 13-75.5 37-105.5L487 76c11-13.8 31.2-16 45-5s16 31.2 5 45zM416 304a80 80 0 1 0 160 0 80 80 0 1 0 -160 0zM32 64c17.7 0 32 14.3 32 32l0 128 192 0 0-128c0-17.7 14.3-32 32-32s32 14.3 32 32l0 160 0 160c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-128L64 288l0 128c0 17.7-14.3 32-32 32s-32-14.3-32-32L0 256 0 96C0 78.3 14.3 64 32 64z"
        }
      )
    })
  );
}), O1 = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M64 144a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM192 64c-17.7 0-32 14.3-32 32s14.3 32 32 32l288 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L192 64zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32l288 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-288 0zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32l288 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-288 0zM64 464a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm48-208a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"
        }
      )
    })
  );
}), Q1 = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M24 56c0-13.3 10.7-24 24-24l32 0c13.3 0 24 10.7 24 24l0 120 16 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l16 0 0-96-8 0C34.7 80 24 69.3 24 56zM86.7 341.2c-6.5-7.4-18.3-6.9-24 1.2L51.5 357.9c-7.7 10.8-22.7 13.3-33.5 5.6s-13.3-22.7-5.6-33.5l11.1-15.6c23.7-33.2 72.3-35.6 99.2-4.9c21.3 24.4 20.8 60.9-1.1 84.7L86.8 432l33.2 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-88 0c-9.5 0-18.2-5.6-22-14.4s-2.1-18.9 4.3-25.9l72-78c5.3-5.8 5.4-14.6 .3-20.5zM224 64l256 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-256 0c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 160l256 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-256 0c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 160l256 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-256 0c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
        }
      )
    })
  );
}), j1 = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 448 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M288 64c0 17.7-14.3 32-32 32L32 96C14.3 96 0 81.7 0 64S14.3 32 32 32l224 0c17.7 0 32 14.3 32 32zm0 256c0 17.7-14.3 32-32 32L32 352c-17.7 0-32-14.3-32-32s14.3-32 32-32l224 0c17.7 0 32 14.3 32 32zM0 192c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 224c-17.7 0-32-14.3-32-32zM448 448c0 17.7-14.3 32-32 32L32 480c-17.7 0-32-14.3-32-32s14.3-32 32-32l384 0c17.7 0 32 14.3 32 32z"
        }
      )
    })
  );
}), W1 = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 448 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M352 64c0-17.7-14.3-32-32-32L128 32c-17.7 0-32 14.3-32 32s14.3 32 32 32l192 0c17.7 0 32-14.3 32-32zm96 128c0-17.7-14.3-32-32-32L32 160c-17.7 0-32 14.3-32 32s14.3 32 32 32l384 0c17.7 0 32-14.3 32-32zM0 448c0 17.7 14.3 32 32 32l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 416c-17.7 0-32 14.3-32 32zM352 320c0-17.7-14.3-32-32-32l-192 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l192 0c17.7 0 32-14.3 32-32z"
        }
      )
    })
  );
}), X1 = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 448 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M448 64c0 17.7-14.3 32-32 32L192 96c-17.7 0-32-14.3-32-32s14.3-32 32-32l224 0c17.7 0 32 14.3 32 32zm0 256c0 17.7-14.3 32-32 32l-224 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l224 0c17.7 0 32 14.3 32 32zM0 192c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 224c-17.7 0-32-14.3-32-32zM448 448c0 17.7-14.3 32-32 32L32 480c-17.7 0-32-14.3-32-32s14.3-32 32-32l384 0c17.7 0 32 14.3 32 32z"
        }
      )
    })
  );
}), J1 = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 448 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M448 64c0-17.7-14.3-32-32-32L32 32C14.3 32 0 46.3 0 64S14.3 96 32 96l384 0c17.7 0 32-14.3 32-32zm0 256c0-17.7-14.3-32-32-32L32 288c-17.7 0-32 14.3-32 32s14.3 32 32 32l384 0c17.7 0 32-14.3 32-32zM0 192c0 17.7 14.3 32 32 32l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 160c-17.7 0-32 14.3-32 32zM448 448c0-17.7-14.3-32-32-32L32 416c-17.7 0-32 14.3-32 32s14.3 32 32 32l384 0c17.7 0 32-14.3 32-32z"
        }
      )
    })
  );
}), K1 = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 640 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M579.8 267.7c56.5-56.5 56.5-148 0-204.5c-50-50-128.8-56.5-186.3-15.4l-1.6 1.1c-14.4 10.3-17.7 30.3-7.4 44.6s30.3 17.7 44.6 7.4l1.6-1.1c32.1-22.9 76-19.3 103.8 8.6c31.5 31.5 31.5 82.5 0 114L422.3 334.8c-31.5 31.5-82.5 31.5-114 0c-27.9-27.9-31.5-71.8-8.6-103.8l1.1-1.6c10.3-14.4 6.9-34.4-7.4-44.6s-34.4-6.9-44.6 7.4l-1.1 1.6C206.5 251.2 213 330 263 380c56.5 56.5 148 56.5 204.5 0L579.8 267.7zM60.2 244.3c-56.5 56.5-56.5 148 0 204.5c50 50 128.8 56.5 186.3 15.4l1.6-1.1c14.4-10.3 17.7-30.3 7.4-44.6s-30.3-17.7-44.6-7.4l-1.6 1.1c-32.1 22.9-76 19.3-103.8-8.6C74 372 74 321 105.5 289.5L217.7 177.2c31.5-31.5 82.5-31.5 114 0c27.9 27.9 31.5 71.8 8.6 103.9l-1.1 1.6c-10.3 14.4-6.9 34.4 7.4 44.6s34.4 6.9 44.6-7.4l1.1-1.6C433.5 260.8 427 182 377 132c-56.5-56.5-148-56.5-204.5 0L60.2 244.3z"
        }
      )
    })
  );
}), Y1 = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 640 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L489.3 358.2l90.5-90.5c56.5-56.5 56.5-148 0-204.5c-50-50-128.8-56.5-186.3-15.4l-1.6 1.1c-14.4 10.3-17.7 30.3-7.4 44.6s30.3 17.7 44.6 7.4l1.6-1.1c32.1-22.9 76-19.3 103.8 8.6c31.5 31.5 31.5 82.5 0 114l-96 96-31.9-25C430.9 239.6 420.1 175.1 377 132c-52.2-52.3-134.5-56.2-191.3-11.7L38.8 5.1zM239 162c30.1-14.9 67.7-9.9 92.8 15.3c20 20 27.5 48.3 21.7 74.5L239 162zM406.6 416.4L220.9 270c-2.1 39.8 12.2 80.1 42.2 110c38.9 38.9 94.4 51 143.6 36.3zm-290-228.5L60.2 244.3c-56.5 56.5-56.5 148 0 204.5c50 50 128.8 56.5 186.3 15.4l1.6-1.1c14.4-10.3 17.7-30.3 7.4-44.6s-30.3-17.7-44.6-7.4l-1.6 1.1c-32.1 22.9-76 19.3-103.8-8.6C74 372 74 321 105.5 289.5l61.8-61.8-50.6-39.9z"
        }
      )
    })
  );
}), $1 = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 640 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M64 128l0-32 96 0 0 320-32 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l128 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-32 0 0-320 96 0 0 32c0 17.7 14.3 32 32 32s32-14.3 32-32l0-48c0-26.5-21.5-48-48-48L192 32 48 32C21.5 32 0 53.5 0 80l0 48c0 17.7 14.3 32 32 32s32-14.3 32-32zM384 304l0-16 64 0 0 128-16 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-16 0 0-128 64 0 0 16c0 17.7 14.3 32 32 32s32-14.3 32-32l0-32c0-26.5-21.5-48-48-48l-224 0c-26.5 0-48 21.5-48 48l0 32c0 17.7 14.3 32 32 32s32-14.3 32-32z"
        }
      )
    })
  );
}), l4 = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 448 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M254 52.8C249.3 40.3 237.3 32 224 32s-25.3 8.3-30 20.8L57.8 416 32 416c-17.7 0-32 14.3-32 32s14.3 32 32 32l96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-1.8 0 18-48 159.6 0 18 48-1.8 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-25.8 0L254 52.8zM279.8 304l-111.6 0L224 155.1 279.8 304z"
        }
      )
    })
  );
}), c4 = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 320 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M31.3 192h257.3c17.8 0 26.7 21.5 14.1 34.1L174.1 354.8c-7.8 7.8-20.5 7.8-28.3 0L17.2 226.1C4.6 213.5 13.5 192 31.3 192z"
        }
      )
    })
  );
}), r4 = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 544 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M0 480L99.9 512l35.5-35.5-67-67L0 480zm124.6-240a36.6 36.6 0 0 0 -10.8 38.1l13.1 42.8-50.9 50.9 96.2 96.2 50.9-50.9 42.7 13.1c13.7 4.2 28.7 0 38.2-10.8l35.6-41.6-173.3-173.3-41.5 35.4zm403.3-160.7l-63.2-63.2c-20.5-20.5-53.4-21.5-75.1-2.4L190.6 183.7l169.8 169.8L530.3 154.4c19.2-21.7 18.2-54.6-2.4-75.1z"
        }
      )
    })
  );
}), e4 = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M464 448H48c-26.5 0-48-21.5-48-48V112c0-26.5 21.5-48 48-48h416c26.5 0 48 21.5 48 48v288c0 26.5-21.5 48-48 48zM112 120c-30.9 0-56 25.1-56 56s25.1 56 56 56 56-25.1 56-56-25.1-56-56-56zM64 384h384V272l-87.5-87.5c-4.7-4.7-12.3-4.7-17 0L208 320l-55.5-55.5c-4.7-4.7-12.3-4.7-17 0L64 336v48z"
        }
      )
    })
  );
}), t4 = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M464 256h-80v-64c0-35.3 28.7-64 64-64h8c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24h-8c-88.4 0-160 71.6-160 160v240c0 26.5 21.5 48 48 48h128c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48zm-288 0H96v-64c0-35.3 28.7-64 64-64h8c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24h-8C71.6 32 0 103.6 0 192v240c0 26.5 21.5 48 48 48h128c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48z"
        }
      )
    })
  );
}), s4 = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 448 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M32 64h32v160c0 88.2 71.8 160 160 160s160-71.8 160-160V64h32a16 16 0 0 0 16-16V16a16 16 0 0 0 -16-16H272a16 16 0 0 0 -16 16v32a16 16 0 0 0 16 16h32v160a80 80 0 0 1 -160 0V64h32a16 16 0 0 0 16-16V16a16 16 0 0 0 -16-16H32a16 16 0 0 0 -16 16v32a16 16 0 0 0 16 16zm400 384H16a16 16 0 0 0 -16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0 -16-16z"
        }
      )
    })
  );
}), o4 = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 640 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M399.1 1.1c-12.7-3.9-26.1 3.1-30 15.8l-144 464c-3.9 12.7 3.1 26.1 15.8 30s26.1-3.1 30-15.8l144-464c3.9-12.7-3.1-26.1-15.8-30zm71.4 118.5c-9.1 9.7-8.6 24.9 1.1 33.9L580.9 256 471.6 358.5c-9.7 9.1-10.2 24.3-1.1 33.9s24.3 10.2 33.9 1.1l128-120c4.8-4.5 7.6-10.9 7.6-17.5s-2.7-13-7.6-17.5l-128-120c-9.7-9.1-24.9-8.6-33.9 1.1zm-301 0c-9.1-9.7-24.3-10.2-33.9-1.1l-128 120C2.7 243 0 249.4 0 256s2.7 13 7.6 17.5l128 120c9.7 9.1 24.9 8.6 33.9-1.1s8.6-24.9-1.1-33.9L59.1 256 168.4 153.5c9.7-9.1 10.2-24.3 1.1-33.9z"
        }
      )
    })
  );
}), i4 = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 640 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M392.8 1.2c-17-4.9-34.7 5-39.6 22l-128 448c-4.9 17 5 34.7 22 39.6s34.7-5 39.6-22l128-448c4.9-17-5-34.7-22-39.6zm80.6 120.1c-12.5 12.5-12.5 32.8 0 45.3L562.7 256l-89.4 89.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l112-112c12.5-12.5 12.5-32.8 0-45.3l-112-112c-12.5-12.5-32.8-12.5-45.3 0zm-306.7 0c-12.5-12.5-32.8-12.5-45.3 0l-112 112c-12.5 12.5-12.5 32.8 0 45.3l112 112c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256l89.4-89.4c12.5-12.5 12.5-32.8 0-45.3z"
        }
      )
    })
  );
}), a4 = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 576 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M290.7 57.4L57.4 290.7c-25 25-25 65.5 0 90.5l80 80c12 12 28.3 18.7 45.3 18.7L288 480l9.4 0L512 480c17.7 0 32-14.3 32-32s-14.3-32-32-32l-124.1 0L518.6 285.3c25-25 25-65.5 0-90.5L381.3 57.4c-25-25-65.5-25-90.5 0zM297.4 416l-9.4 0-105.4 0-80-80L227.3 211.3 364.7 348.7 297.4 416z"
        }
      )
    })
  );
}), h4 = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 576 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M118.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-64 64c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l9.4-9.4 0 229.5-9.4-9.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 12.5 45.3l64 64c12.5 12.5 32.8 12.5 45.3 0l64-64c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-9.4 9.4 0-229.5 9.4 9.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-64-64zM288 64c-17.7 0-32 14.3-32 32s14.3 32 32 32l256 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L288 64zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32l256 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-256 0zM256 416c0 17.7 14.3 32 32 32l256 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-256 0c-17.7 0-32 14.3-32 32z"
        }
      )
    })
  );
}), d4 = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M40 48C26.7 48 16 58.7 16 72l0 48c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24L40 48zM184 72c-13.3 0-24 10.7-24 24s10.7 24 24 24l304 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L184 72zm0 160c-13.3 0-24 10.7-24 24s10.7 24 24 24l304 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-304 0zm0 160c-13.3 0-24 10.7-24 24s10.7 24 24 24l304 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-304 0zM16 232l0 48c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24zM40 368c-13.3 0-24 10.7-24 24l0 48c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0z"
        }
      )
    })
  );
}), w4 = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M48 264l0-104 184 0 0 104L48 264zm0 48l184 0 0 120L64 432c-8.8 0-16-7.2-16-16l0-104zM280 432l0-120 184 0 0 104c0 8.8-7.2 16-16 16l-168 0zM464 264l-184 0 0-104 184 0 0 104zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32z"
        }
      )
    })
  );
}), n4 = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 448 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M88 72l0 48-48 0 0-48 48 0zM40 32C17.9 32 0 49.9 0 72l0 48c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40L40 32zM88 232l0 48-48 0 0-48 48 0zM40 192c-22.1 0-40 17.9-40 40l0 48c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40l-48 0zm0 200l48 0 0 48-48 0 0-48zM0 392l0 48c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40zM248 72l0 48-48 0 0-48 48 0zM200 32c-22.1 0-40 17.9-40 40l0 48c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40l-48 0zm0 200l48 0 0 48-48 0 0-48zm-40 0l0 48c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40zm88 160l0 48-48 0 0-48 48 0zm-48-40c-22.1 0-40 17.9-40 40l0 48c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40l-48 0zM360 72l48 0 0 48-48 0 0-48zm-40 0l0 48c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40zm88 160l0 48-48 0 0-48 48 0zm-48-40c-22.1 0-40 17.9-40 40l0 48c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40l-48 0zm0 200l48 0 0 48-48 0 0-48zm-40 0l0 48c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40z"
        }
      )
    })
  );
}), g4 = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 448 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M0 424c0 13.3 10.7 24 24 24s24-10.7 24-24L48 88c0-13.3-10.7-24-24-24S0 74.7 0 88L0 424zM135.6 238.5c-4.8 4.5-7.6 10.9-7.6 17.5s2.7 12.9 7.6 17.5l136 128c9.7 9.1 24.8 8.6 33.9-1s8.6-24.8-1-33.9L212.5 280l83.5 0 128 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-128 0-83.5 0 91.9-86.5c9.7-9.1 10.1-24.3 1-33.9s-24.3-10.1-33.9-1l-136 128z"
        }
      )
    })
  );
}), f4 = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 448 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M448 88c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 336c0 13.3 10.7 24 24 24s24-10.7 24-24l0-336zM312.4 273.5c4.8-4.5 7.6-10.9 7.6-17.5s-2.7-12.9-7.6-17.5l-136-128c-9.7-9.1-24.8-8.6-33.9 1s-8.6 24.8 1 33.9L235.5 232 152 232 24 232c-13.3 0-24 10.7-24 24s10.7 24 24 24l128 0 83.5 0-91.9 86.5c-9.7 9.1-10.1 24.3-1 33.9s24.3 10.1 33.9 1l136-128z"
        }
      )
    })
  );
}), L4 = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 384 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M24 32C10.7 32 0 42.7 0 56S10.7 80 24 80l336 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 32zM209.5 167.6c-4.5-4.8-10.9-7.6-17.5-7.6s-12.9 2.7-17.5 7.6l-128 136c-9.1 9.7-8.6 24.8 1 33.9s24.8 8.6 33.9-1L168 244.5l0 83.5 0 128c0 13.3 10.7 24 24 24s24-10.7 24-24l0-128 0-83.5 86.5 91.9c9.1 9.7 24.3 10.1 33.9 1s10.1-24.3 1-33.9l-128-136z"
        }
      )
    })
  );
}), m4 = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 448 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM200 344l0-64-64 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l64 0 0-64c0-13.3 10.7-24 24-24s24 10.7 24 24l0 64 64 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-64 0 0 64c0 13.3-10.7 24-24 24s-24-10.7-24-24z"
        }
      )
    })
  );
}), C4 = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M0 88C0 74.7 10.7 64 24 64l72 0 48.2 0c17.5 0 34 8.2 44.5 22.1L297.5 228.8c1.5 2 3.9 3.2 6.4 3.2l126.2 0-39-39c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l80 80c9.4 9.4 9.4 24.6 0 33.9l-80 80c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l39-39-126.2 0c-2.5 0-4.9 1.2-6.4 3.2L188.7 425.9c-10.6 13.9-27.1 22.1-44.5 22.1L96 448l-72 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l72 0 48.2 0c2.5 0 4.9-1.2 6.4-3.2L257.8 256 150.5 115.2c-1.5-2-3.9-3.2-6.4-3.2L96 112l-72 0C10.7 112 0 101.3 0 88z"
        }
      )
    })
  );
}), v4 = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M391 31c9.4-9.4 24.6-9.4 33.9 0l80 80c9.4 9.4 9.4 24.6 0 33.9l-80 80c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l39-39-83.5 0c-10.6 0-20.8 4.2-28.3 11.7L225.9 256l92.3 92.3c7.5 7.5 17.7 11.7 28.3 11.7l83.5 0-39-39c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l80 80c9.4 9.4 9.4 24.6 0 33.9l-80 80c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l39-39-83.5 0c-23.3 0-45.7-9.3-62.2-25.8L182.1 280 24 280c-13.3 0-24-10.7-24-24s10.7-24 24-24l158.1 0L284.3 129.8c16.5-16.5 38.9-25.8 62.2-25.8l83.5 0L391 65c-9.4-9.4-9.4-24.6 0-33.9z"
        }
      )
    })
  );
}), M4 = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM448 96l0 64L64 160l0-64 384 0zM64 224l64 0 0 192-64 0 0-192zm384 0l0 192-256 0 0-192 256 0z"
        }
      )
    })
  );
}), z4 = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 640 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 96.7c-5.3-.5-10.6-.7-16-.7c-37.7 0-72.6 11.8-101.2 32L192 224l0 192 134.6 0c6.7 23.8 18.3 45.5 33.6 64L64 480c-35.3 0-64-28.7-64-64L0 96zm64 0l0 64 384 0 0-64L64 96zm0 128l0 192 64 0 0-192-64 0zM352 368c0-79.5 64.5-144 144-144s144 64.5 144 144s-64.5 144-144 144s-144-64.5-144-144zm64 0c0 8.8 7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0 0-48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48-48 0c-8.8 0-16 7.2-16 16z"
        }
      )
    })
  );
}), p4 = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm64 0l0 64 64 0 0-64L64 96zm384 0L192 96l0 64 256 0 0-64zM64 224l0 64 64 0 0-64-64 0zm384 0l-256 0 0 64 256 0 0-64zM64 352l0 64 64 0 0-64-64 0zm384 0l-256 0 0 64 256 0 0-64z"
        }
      )
    })
  );
}), F4 = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 448 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 144L48 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l144 0 0 144c0 17.7 14.3 32 32 32s32-14.3 32-32l0-144 144 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-144 0 0-144z"
        }
      )
    })
  );
}), u4 = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 448 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M432 256c0 17.7-14.3 32-32 32L48 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l352 0c17.7 0 32 14.3 32 32z"
        }
      )
    })
  );
}), x4 = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 576 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M304 240V16.6c0-9 7-16.6 16-16.6C443.7 0 544 100.3 544 224c0 9-7.6 16-16.6 16H304zM32 272C32 150.7 122.1 50.3 239 34.3c9.2-1.3 17 6.1 17 15.4V288L412.5 444.5c6.7 6.7 6.2 17.7-1.5 23.1C371.8 495.6 323.8 512 272 512C139.5 512 32 404.6 32 272zm526.4 16c9.3 0 16.6 7.8 15.4 17c-7.7 55.9-34.6 105.6-73.9 142.3c-6 5.6-15.4 5.2-21.2-.7L320 288H558.4z"
        }
      )
    })
  );
}), A4 = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M32 32c17.7 0 32 14.3 32 32V400c0 8.8 7.2 16 16 16H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H80c-44.2 0-80-35.8-80-80V64c0-17.7 14.3-32 32-32zm96 96c0-17.7 14.3-32 32-32l32 0c17.7 0 32 14.3 32 32l0 192c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-192zm128-32c17.7 0 32 14.3 32 32l0 256c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-256c0-17.7 14.3-32 32-32l32 0zM416 288c0-17.7 14.3-32 32-32l32 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-64z"
        }
      )
    })
  );
}), y4 = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M192 104.8c0-9.2-5.8-17.3-13.2-22.8C167.2 73.3 160 61.3 160 48c0-26.5 28.7-48 64-48s64 21.5 64 48c0 13.3-7.2 25.3-18.8 34c-7.4 5.5-13.2 13.6-13.2 22.8c0 12.8 10.4 23.2 23.2 23.2l56.8 0c26.5 0 48 21.5 48 48l0 56.8c0 12.8 10.4 23.2 23.2 23.2c9.2 0 17.3-5.8 22.8-13.2c8.7-11.6 20.7-18.8 34-18.8c26.5 0 48 28.7 48 64s-21.5 64-48 64c-13.3 0-25.3-7.2-34-18.8c-5.5-7.4-13.6-13.2-22.8-13.2c-12.8 0-23.2 10.4-23.2 23.2L384 464c0 26.5-21.5 48-48 48l-56.8 0c-12.8 0-23.2-10.4-23.2-23.2c0-9.2 5.8-17.3 13.2-22.8c11.6-8.7 18.8-20.7 18.8-34c0-26.5-28.7-48-64-48s-64 21.5-64 48c0 13.3 7.2 25.3 18.8 34c7.4 5.5 13.2 13.6 13.2 22.8c0 12.8-10.4 23.2-23.2 23.2L48 512c-26.5 0-48-21.5-48-48L0 343.2C0 330.4 10.4 320 23.2 320c9.2 0 17.3 5.8 22.8 13.2C54.7 344.8 66.7 352 80 352c26.5 0 48-28.7 48-64s-21.5-64-48-64c-13.3 0-25.3 7.2-34 18.8C40.5 250.2 32.4 256 23.2 256C10.4 256 0 245.6 0 232.8L0 176c0-26.5 21.5-48 48-48l120.8 0c12.8 0 23.2-10.4 23.2-23.2z"
        }
      )
    })
  );
}), x = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 576 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: d ? "M264.5 5.2c14.9-6.9 32.1-6.9 47 0l218.6 101c8.5 3.9 13.9 12.4 13.9 21.8s-5.4 17.9-13.9 21.8l-218.6 101c-14.9 6.9-32.1 6.9-47 0L45.9 149.8C37.4 145.8 32 137.3 32 128s5.4-17.9 13.9-21.8L264.5 5.2zM476.9 209.6l53.2 24.6c8.5 3.9 13.9 12.4 13.9 21.8s-5.4 17.9-13.9 21.8l-218.6 101c-14.9 6.9-32.1 6.9-47 0L45.9 277.8C37.4 273.8 32 265.3 32 256s5.4-17.9 13.9-21.8l53.2-24.6 152 70.2c23.4 10.8 50.4 10.8 73.8 0l152-70.2zm-152 198.2l152-70.2 53.2 24.6c8.5 3.9 13.9 12.4 13.9 21.8s-5.4 17.9-13.9 21.8l-218.6 101c-14.9 6.9-32.1 6.9-47 0L45.9 405.8C37.4 401.8 32 393.3 32 384s5.4-17.9 13.9-21.8l53.2-24.6 152 70.2c23.4 10.8 50.4 10.8 73.8 0z" : "M288 0c-8.5 0-17 1.7-24.8 5.1L53.9 94.8C40.6 100.5 32 113.5 32 128s8.6 27.5 21.9 33.2l209.3 89.7c7.8 3.4 16.3 5.1 24.8 5.1s17-1.7 24.8-5.1l209.3-89.7c13.3-5.7 21.9-18.8 21.9-33.2s-8.6-27.5-21.9-33.2L312.8 5.1C305 1.7 296.5 0 288 0zm-5.9 49.2C284 48.4 286 48 288 48s4 .4 5.9 1.2L477.7 128 293.9 206.8c-1.9 .8-3.9 1.2-5.9 1.2s-4-.4-5.9-1.2L98.3 128 282.1 49.2zM53.9 222.8C40.6 228.5 32 241.5 32 256s8.6 27.5 21.9 33.2l209.3 89.7c7.8 3.4 16.3 5.1 24.8 5.1s17-1.7 24.8-5.1l209.3-89.7c13.3-5.7 21.9-18.8 21.9-33.2s-8.6-27.5-21.9-33.2l-31.2-13.4L430 235.5 477.7 256 293.9 334.8c-1.9 .8-3.9 1.2-5.9 1.2s-4-.4-5.9-1.2L98.3 256 146 235.5 85.1 209.4 53.9 222.8zm0 128C40.6 356.5 32 369.5 32 384s8.6 27.5 21.9 33.2l209.3 89.7c7.8 3.4 16.3 5.1 24.8 5.1s17-1.7 24.8-5.1l209.3-89.7c13.3-5.7 21.9-18.8 21.9-33.2s-8.6-27.5-21.9-33.2l-31.2-13.4L430 363.5 477.7 384 293.9 462.8c-1.9 .8-3.9 1.2-5.9 1.2s-4-.4-5.9-1.2L98.3 384 146 363.5 85.1 337.4 53.9 350.8z"
        }
      )
    })
  );
});
x.displayName = "LayerGroupFarFAIcon";
const A = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M386.3 160L336 160c-17.7 0-32 14.3-32 32s14.3 32 32 32l128 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 51.2L414.4 97.6c-87.5-87.5-229.3-87.5-316.8 0s-87.5 229.3 0 316.8s229.3 87.5 316.8 0c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0c-62.5 62.5-163.8 62.5-226.3 0s-62.5-163.8 0-226.3s163.8-62.5 226.3 0L386.3 160z"
        }
      )
    })
  );
});
A.displayName = "ArrowRotateRightFAIcon";
const y = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M125.7 160l50.3 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L48 224c-17.7 0-32-14.3-32-32L16 64c0-17.7 14.3-32 32-32s32 14.3 32 32l0 51.2L97.6 97.6c87.5-87.5 229.3-87.5 316.8 0s87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3s-163.8-62.5-226.3 0L125.7 160z"
        }
      )
    })
  );
});
y.displayName = "ArrowRotateLeftFAIcon";
const I = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 384 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M320 464c8.8 0 16-7.2 16-16l0-288-80 0c-17.7 0-32-14.3-32-32l0-80L64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16l256 0zM0 64C0 28.7 28.7 0 64 0L229.5 0c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3L384 448c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64z"
        }
      )
    })
  );
});
I.displayName = "FileFarFAIcon";
const R = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M448 80c8.8 0 16 7.2 16 16l0 319.8-5-6.5-136-176c-4.5-5.9-11.6-9.3-19-9.3s-14.4 3.4-19 9.3L202 340.7l-30.5-42.7C167 291.7 159.8 288 152 288s-15 3.7-19.5 10.1l-80 112L48 416.3l0-.3L48 96c0-8.8 7.2-16 16-16l384 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm80 192a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"
        }
      )
    })
  );
});
R.displayName = "ImageFarFAIcon";
const B = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 576 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M64 112c-8.8 0-16 7.2-16 16l0 256c0 8.8 7.2 16 16 16l256 0c8.8 0 16-7.2 16-16l0-256c0-8.8-7.2-16-16-16L64 112zM0 128C0 92.7 28.7 64 64 64l256 0c35.3 0 64 28.7 64 64l0 33 0 190 0 33c0 35.3-28.7 64-64 64L64 448c-35.3 0-64-28.7-64-64L0 128zM528 363.4l0-214.7L416 199l0-52.6L520.3 99.5c5.1-2.3 10.6-3.5 16.2-3.5c21.8 0 39.5 17.7 39.5 39.5l0 241c0 21.8-17.7 39.5-39.5 39.5c-5.6 0-11.1-1.2-16.2-3.5L416 365.6l0-52.6 112 50.4z"
        }
      )
    })
  );
});
B.displayName = "VideoFarFAIcon";
const V = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M64 464l48 0 0 48-48 0c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L229.5 0c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3L384 304l-48 0 0-144-80 0c-17.7 0-32-14.3-32-32l0-80L64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16zM176 352l32 0c30.9 0 56 25.1 56 56s-25.1 56-56 56l-16 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48 0-80c0-8.8 7.2-16 16-16zm32 80c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0 0 48 16 0zm96-80l32 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-32 0c-8.8 0-16-7.2-16-16l0-128c0-8.8 7.2-16 16-16zm32 128c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-16 0 0 96 16 0zm80-112c0-8.8 7.2-16 16-16l48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 32 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64 0-64z"
        }
      )
    })
  );
});
V.displayName = "FilePdfFarFAIcon";
const H = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 384 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M48 448L48 64c0-8.8 7.2-16 16-16l160 0 0 80c0 17.7 14.3 32 32 32l80 0 0 288c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-293.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0L64 0zm55 241.1c-3.8-12.7-17.2-19.9-29.9-16.1s-19.9 17.2-16.1 29.9l48 160c3 10.2 12.4 17.1 23 17.1s19.9-7 23-17.1l25-83.4 25 83.4c3 10.2 12.4 17.1 23 17.1s19.9-7 23-17.1l48-160c3.8-12.7-3.4-26.1-16.1-29.9s-26.1 3.4-29.9 16.1l-25 83.4-25-83.4c-3-10.2-12.4-17.1-23-17.1s-19.9 7-23 17.1l-25 83.4-25-83.4z"
        }
      )
    })
  );
});
H.displayName = "FileWordFarFAIcon";
const S = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 384 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M48 448L48 64c0-8.8 7.2-16 16-16l160 0 0 80c0 17.7 14.3 32 32 32l80 0 0 288c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-293.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0L64 0zm90.9 233.3c-8.1-10.5-23.2-12.3-33.7-4.2s-12.3 23.2-4.2 33.7L161.6 320l-44.5 57.3c-8.1 10.5-6.3 25.5 4.2 33.7s25.5 6.3 33.7-4.2L192 359.1l37.1 47.6c8.1 10.5 23.2 12.3 33.7 4.2s12.3-23.2 4.2-33.7L222.4 320l44.5-57.3c8.1-10.5 6.3-25.5-4.2-33.7s-25.5-6.3-33.7 4.2L192 280.9l-37.1-47.6z"
        }
      )
    })
  );
});
S.displayName = "FileExcelFarFAIcon";
const N = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 384 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M64 464c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l160 0 0 80c0 17.7 14.3 32 32 32l80 0 0 288c0 8.8-7.2 16-16 16L64 464zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-293.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0L64 0zm72 208c-13.3 0-24 10.7-24 24l0 104 0 56c0 13.3 10.7 24 24 24s24-10.7 24-24l0-32 44 0c42 0 76-34 76-76s-34-76-76-76l-68 0zm68 104l-44 0 0-56 44 0c15.5 0 28 12.5 28 28s-12.5 28-28 28z"
        }
      )
    })
  );
});
N.displayName = "FilePowerPointFarFAIcon";
const k = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M64 464l112 0 0 48L64 512c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L229.5 0c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3L384 304l-48 0 0-144-80 0c-17.7 0-32-14.3-32-32l0-80L64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16zM240 352l64 0c5.5 0 10.7 2.9 13.6 7.6s3.2 10.6 .7 15.6L265.9 480l38.1 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-5.5 0-10.7-2.9-13.6-7.6s-3.2-10.6-.7-15.6L278.1 384 240 384c-8.8 0-16-7.2-16-16s7.2-16 16-16zm144 16l0 128c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-128c0-8.8 7.2-16 16-16s16 7.2 16 16zm32 0c0-8.8 7.2-16 16-16l24 0c30.9 0 56 25.1 56 56s-25.1 56-56 56l-8 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48 0-80zm32 64l8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0 48z"
        }
      )
    })
  );
});
k.displayName = "FileZipFarFAIcon";
const T = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 576 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M191.9 201.9L304 102.3l0 307.3L191.9 310.1c-4.4-3.9-10.1-6.1-15.9-6.1l-88 0c-4.4 0-8-3.6-8-8l0-80c0-4.4 3.6-8 8-8l88 0c5.9 0 11.6-2.2 15.9-6.1zM322.2 32c-7.3 0-14.3 2.7-19.8 7.5L166.9 160 88 160c-30.9 0-56 25.1-56 56l0 80c0 30.9 25.1 56 56 56l78.9 0L302.4 472.5c5.5 4.8 12.5 7.5 19.8 7.5c16.5 0 29.8-13.3 29.8-29.8l0-388.4C352 45.3 338.7 32 322.2 32zm182.9 75c-10.3-8.4-25.4-6.8-33.8 3.5s-6.8 25.4 3.5 33.8C507.3 170.7 528 210.9 528 256s-20.7 85.3-53.2 111.8c-10.3 8.4-11.8 23.5-3.5 33.8s23.5 11.8 33.8 3.5c43.2-35.2 70.9-88.9 70.9-149s-27.7-113.8-70.9-149zm-60.5 74.5c-10.3-8.4-25.4-6.8-33.8 3.5s-6.8 25.4 3.5 33.8C425.1 227.6 432 241 432 256s-6.9 28.4-17.7 37.3c-10.3 8.4-11.8 23.5-3.5 33.8s23.5 11.8 33.8 3.5C466.1 312.9 480 286.1 480 256s-13.9-56.9-35.4-74.5z"
        }
      )
    })
  );
});
T.displayName = "VolumeFarFAIcon";
const P = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 384 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: d ? "M32 32C32 14.3 46.3 0 64 0L320 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-29.5 0 11.4 148.2c36.7 19.9 65.7 53.2 79.5 94.7l1 3c3.3 9.8 1.6 20.5-4.4 28.8s-15.7 13.3-26 13.3L32 352c-10.3 0-19.9-4.9-26-13.3s-7.7-19.1-4.4-28.8l1-3c13.8-41.5 42.8-74.8 79.5-94.7L93.5 64 64 64C46.3 64 32 49.7 32 32zM160 384l64 0 0 96c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-96z" : "M134.6 51.7L123.8 192.6c-1.1 14.6-8.8 27.8-20.9 36C79 244.8 61.1 269.4 53.8 298.9L52.5 304 168 304l0-88c0-13.3 10.7-24 24-24s24 10.7 24 24l0 88 115.5 0-1.3-5.1c-7.4-29.5-25.2-54.1-49.1-70.2c-12.1-8.2-19.8-21.5-20.9-36L249.4 51.7c-.1-1.2-.1-2.5-.1-3.7L134.8 48c0 1.2 0 2.5-.1 3.7zM168 352L32 352c-9.9 0-19.2-4.5-25.2-12.3S-1.4 321.8 1 312.2l6.2-25c10.3-41.3 35.4-75.7 68.7-98.3L83.1 96l3.7-48L56 48c-4.4 0-8.6-1.2-12.2-3.3C36.8 40.5 32 32.8 32 24C32 10.7 42.7 0 56 0L86.8 0 297.2 0 328 0c13.3 0 24 10.7 24 24c0 8.8-4.8 16.5-11.8 20.7c-3.6 2.1-7.7 3.3-12.2 3.3l-30.8 0 3.7 48 7.1 92.9c33.3 22.6 58.4 57.1 68.7 98.3l6.2 25c2.4 9.6 .2 19.7-5.8 27.5s-15.4 12.3-25.2 12.3l-136 0 0 136c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-136z"
        }
      )
    })
  );
});
P.displayName = "ThumbTackFarFAIcon";
const U = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: d ? "M3.9 54.9C10.5 40.9 24.5 32 40 32l432 0c15.5 0 29.5 8.9 36.1 22.9s4.6 30.5-5.2 42.5L320 320.9 320 448c0 12.1-6.8 23.2-17.7 28.6s-23.8 4.3-33.5-3l-64-48c-8.1-6-12.8-15.5-12.8-25.6l0-79.1L9 97.3C-.7 85.4-2.8 68.8 3.9 54.9z" : "M0 73.7C0 50.7 18.7 32 41.7 32l428.6 0c23 0 41.7 18.7 41.7 41.7c0 9.6-3.3 18.9-9.4 26.3L336 304.5l0 143.2c0 17.8-14.5 32.3-32.3 32.3c-7.3 0-14.4-2.5-20.1-7l-92.5-73.4c-9.6-7.6-15.1-19.1-15.1-31.3l0-63.7L9.4 100C3.3 92.6 0 83.3 0 73.7zM55 80L218.6 280.8c3.5 4.3 5.4 9.6 5.4 15.2l0 68.4 64 50.8L288 296c0-5.5 1.9-10.9 5.4-15.2L457 80 55 80z"
        }
      )
    })
  );
});
U.displayName = "FilterFarFAIcon";
const b = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 640 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: d ? "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L406.6 293.4 567 97.3c9.8-12 11.8-28.5 5.2-42.5S551.5 32 536 32L104 32c-8.1 0-15.8 2.5-22.3 6.8L38.8 5.1zM384 398.5L256 297.7 256 400c0 10.1 4.7 19.6 12.8 25.6l64 48c9.7 7.3 22.7 8.4 33.5 3s17.7-16.5 17.7-28.6l0-49.5z" : "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L408.1 294.6 566.6 100c6.1-7.4 9.4-16.7 9.4-26.3c0-23-18.7-41.7-41.7-41.7l-429 0c-8.6 0-16.5 2.6-23.1 7.1L38.8 5.1zM134.4 80L521 80 370.3 265 134.4 80zM400 411.2l-48-37.8 0 41.9-64-50.8 0-41.5-48-37.8 0 83.2c0 12.2 5.6 23.7 15.1 31.3L347.6 473c5.7 4.5 12.8 7 20.1 7c17.8 0 32.3-14.5 32.3-32.3l0-36.5z"
        }
      )
    })
  );
});
b.displayName = "FilterSlashFarFAIcon";
const E = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 384 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: d ? "M48 0C21.5 0 0 21.5 0 48L0 464c0 26.5 21.5 48 48 48l96 0 0-80c0-26.5 21.5-48 48-48s48 21.5 48 48l0 80 96 0c26.5 0 48-21.5 48-48l0-416c0-26.5-21.5-48-48-48L48 0zM64 240c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm112-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zM80 96l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zM272 96l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16z" : "M64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16l80 0 0-64c0-26.5 21.5-48 48-48s48 21.5 48 48l0 64 80 0c8.8 0 16-7.2 16-16l0-384c0-8.8-7.2-16-16-16L64 48zM0 64C0 28.7 28.7 0 64 0L320 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zm88 40c0-8.8 7.2-16 16-16l48 0c8.8 0 16 7.2 16 16l0 48c0 8.8-7.2 16-16 16l-48 0c-8.8 0-16-7.2-16-16l0-48zM232 88l48 0c8.8 0 16 7.2 16 16l0 48c0 8.8-7.2 16-16 16l-48 0c-8.8 0-16-7.2-16-16l0-48c0-8.8 7.2-16 16-16zM88 232c0-8.8 7.2-16 16-16l48 0c8.8 0 16 7.2 16 16l0 48c0 8.8-7.2 16-16 16l-48 0c-8.8 0-16-7.2-16-16l0-48zm144-16l48 0c8.8 0 16 7.2 16 16l0 48c0 8.8-7.2 16-16 16l-48 0c-8.8 0-16-7.2-16-16l0-48c0-8.8 7.2-16 16-16z"
        }
      )
    })
  );
});
E.displayName = "BuildingFarFAIcon";
const z = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: d ? "M224 80c0-26.5-21.5-48-48-48L80 32C53.5 32 32 53.5 32 80l0 96c0 26.5 21.5 48 48 48l96 0c26.5 0 48-21.5 48-48l0-96zm0 256c0-26.5-21.5-48-48-48l-96 0c-26.5 0-48 21.5-48 48l0 96c0 26.5 21.5 48 48 48l96 0c26.5 0 48-21.5 48-48l0-96zM288 80l0 96c0 26.5 21.5 48 48 48l96 0c26.5 0 48-21.5 48-48l0-96c0-26.5-21.5-48-48-48l-96 0c-26.5 0-48 21.5-48 48zM480 336c0-26.5-21.5-48-48-48l-96 0c-26.5 0-48 21.5-48 48l0 96c0 26.5 21.5 48 48 48l96 0c26.5 0 48-21.5 48-48l0-96z" : "M80 80l0 96 96 0 0-96L80 80zM32 80c0-26.5 21.5-48 48-48l96 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-96zM80 336l0 96 96 0 0-96-96 0zm-48 0c0-26.5 21.5-48 48-48l96 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-96zM432 80l-96 0 0 96 96 0 0-96zM336 32l96 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-96c0-26.5 21.5-48 48-48zm0 304l0 96 96 0 0-96-96 0zm-48 0c0-26.5 21.5-48 48-48l96 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-96z"
        }
      )
    })
  );
});
z.displayName = "Grid2FarFAIcon";
z.displayName = "Grid2FarFAIcon";
const Z = f.forwardRef((h, a) => {
  var w = h, { ariaHidden: r = "true", color: e, size: d = 16, style: l } = w, i = g(w, ["ariaHidden", "color", "size", "style"]);
  return /* @__PURE__ */ M(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      "aria-hidden": r,
      color: e,
      ref: a,
      role: "img",
      style: s({ width: o(d), height: o(d) }, l)
    }, i), {
      children: [
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            d: "M11.5103 4.19165H2.58244C1.19051 4.19165 0.10791 5.31292 0.10791 6.66618V17.8015C0.10791 19.1935 1.19051 20.2761 2.58244 20.2761H6.29422V23.3692C6.29422 23.6399 6.41022 23.8332 6.60354 23.9492C6.83553 24.0265 7.06751 24.0265 7.26083 23.8719L7.91813 23.3692L8.11145 23.2532L8.15012 23.2146L12.0552 20.2761H17.4296C18.7828 20.2761 19.9041 19.1935 19.9041 17.8015V12.3162C19.5826 12.4327 19.2377 12.4952 18.8818 12.4952C18.5983 12.4952 18.3177 12.4562 18.0482 12.3805V17.8015C18.0482 18.1495 17.7389 18.4202 17.4296 18.4202H12.0552C11.6299 18.4202 11.2433 18.5748 10.934 18.8068L8.15012 20.8947V20.2761C8.15012 19.2708 7.2995 18.4202 6.29422 18.4202H2.58244C2.23446 18.4202 1.9638 18.1495 1.9638 17.8015V6.66618C1.9638 6.35686 2.23446 6.04754 2.58244 6.04754H11.5766C11.4583 5.71713 11.397 5.36601 11.397 5.0103C11.397 4.72846 11.4362 4.45353 11.5103 4.19165Z"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            d: "M12.655 11.0357L12.2291 10.12C12.2007 10.0632 12.1439 10.0206 12.08 10.0206C12.009 10.0206 11.9522 10.0632 11.9238 10.12L11.4979 11.0357L10.5823 11.4616C10.5255 11.49 10.49 11.5468 10.49 11.6106C10.49 11.6816 10.5255 11.7384 10.5823 11.7668L11.4979 12.1927L11.9238 13.1084C11.9522 13.1652 12.009 13.2007 12.08 13.2007C12.1439 13.2007 12.2007 13.1652 12.2291 13.1084L12.655 12.1927L13.5707 11.7668C13.6274 11.7384 13.67 11.6816 13.67 11.6106C13.67 11.5468 13.6274 11.49 13.5707 11.4616L12.655 11.0357Z"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M19.3516 0.313145L20.6937 3.19856L23.5791 4.54061C23.758 4.63008 23.8922 4.80902 23.8922 5.01032C23.8922 5.234 23.758 5.41294 23.5791 5.50241L20.6937 6.84446L19.3516 9.72987C19.2622 9.90881 19.0832 10.0206 18.8819 10.0206C18.6582 10.0206 18.4793 9.90881 18.3898 9.72987L17.0478 6.84446L14.1624 5.50241C13.9834 5.41294 13.8716 5.234 13.8716 5.01032C13.8716 4.80902 13.9834 4.63008 14.1624 4.54061L17.0478 3.19856L18.3898 0.313145C18.4793 0.134205 18.6582 0 18.8819 0C19.0832 0 19.2622 0.134205 19.3516 0.313145Z"
          }
        )
      ]
    })
  );
});
Z.displayName = "CopilotIcon";
const G = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 640 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: d ? "M323.4 85.2l-96.8 78.4c-16.1 13-19.2 36.4-7 53.1c12.9 17.8 38 21.3 55.3 7.8l99.3-77.2c7-5.4 17-4.2 22.5 2.8s4.2 17-2.8 22.5l-20.9 16.2L512 316.8 512 128l-.7 0-3.9-2.5L434.8 79c-15.3-9.8-33.2-15-51.4-15c-21.8 0-43 7.5-60 21.2zm22.8 124.4l-51.7 40.2C263 274.4 217.3 268 193.7 235.6c-22.2-30.5-16.6-73.1 12.7-96.8l83.2-67.3c-11.6-4.9-24.1-7.4-36.8-7.4C234 64 215.7 69.6 200 80l-72 48 0 224 28.2 0 91.4 83.4c19.6 17.9 49.9 16.5 67.8-3.1c5.5-6.1 9.2-13.2 11.1-20.6l17 15.6c19.5 17.9 49.9 16.6 67.8-2.9c4.5-4.9 7.8-10.6 9.9-16.5c19.4 13 45.8 10.3 62.1-7.5c17.9-19.5 16.6-49.9-2.9-67.8l-134.2-123zM16 128c-8.8 0-16 7.2-16 16L0 352c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-224-80 0zM48 320a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM544 128l0 224c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-208c0-8.8-7.2-16-16-16l-80 0zm32 208a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z" : "M272.2 64.6l-51.1 51.1c-15.3 4.2-29.5 11.9-41.5 22.5L153 161.9C142.8 171 129.5 176 115.8 176L96 176l0 128c20.4 .6 39.8 8.9 54.3 23.4l35.6 35.6 7 7c0 0 0 0 0 0L219.9 397c6.2 6.2 16.4 6.2 22.6 0c1.7-1.7 3-3.7 3.7-5.8c2.8-7.7 9.3-13.5 17.3-15.3s16.4 .6 22.2 6.5L296.5 393c11.6 11.6 30.4 11.6 41.9 0c5.4-5.4 8.3-12.3 8.6-19.4c.4-8.8 5.6-16.6 13.6-20.4s17.3-3 24.4 2.1c9.4 6.7 22.5 5.8 30.9-2.6c9.4-9.4 9.4-24.6 0-33.9L340.1 243l-35.8 33c-27.3 25.2-69.2 25.6-97 .9c-31.7-28.2-32.4-77.4-1.6-106.5l70.1-66.2C303.2 78.4 339.4 64 377.1 64c36.1 0 71 13.3 97.9 37.2L505.1 128l38.9 0 40 0 40 0c8.8 0 16 7.2 16 16l0 208c0 17.7-14.3 32-32 32l-32 0c-11.8 0-22.2-6.4-27.7-16l-84.9 0c-3.4 6.7-7.9 13.1-13.5 18.7c-17.1 17.1-40.8 23.8-63 20.1c-3.6 7.3-8.5 14.1-14.6 20.2c-27.3 27.3-70 30-100.4 8.1c-25.1 20.8-62.5 19.5-86-4.1L159 404l-7-7-35.6-35.6c-5.5-5.5-12.7-8.7-20.4-9.3C96 369.7 81.6 384 64 384l-32 0c-17.7 0-32-14.3-32-32L0 144c0-8.8 7.2-16 16-16l40 0 40 0 19.8 0c2 0 3.9-.7 5.3-2l26.5-23.6C175.5 77.7 211.4 64 248.7 64L259 64c4.4 0 8.9 .2 13.2 .6zM544 320l0-144-48 0c-5.9 0-11.6-2.2-15.9-6.1l-36.9-32.8c-18.2-16.2-41.7-25.1-66.1-25.1c-25.4 0-49.8 9.7-68.3 27.1l-70.1 66.2c-10.3 9.8-10.1 26.3 .5 35.7c9.3 8.3 23.4 8.1 32.5-.3l71.9-66.4c9.7-9 24.9-8.4 33.9 1.4s8.4 24.9-1.4 33.9l-.8 .8 74.4 74.4c10 10 16.5 22.3 19.4 35.1l74.8 0zM64 336a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm528 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"
        }
      )
    })
  );
});
G.displayName = "HandshakeFarFAIcon";
const D = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: d ? "M105.1 202.6c7.7-21.8 20.2-42.3 37.8-59.8c62.5-62.5 163.8-62.5 226.3 0L386.3 160 352 160c-17.7 0-32 14.3-32 32s14.3 32 32 32l111.5 0c0 0 0 0 0 0l.4 0c17.7 0 32-14.3 32-32l0-112c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 35.2L414.4 97.6c-87.5-87.5-229.3-87.5-316.8 0C73.2 122 55.6 150.7 44.8 181.4c-5.9 16.7 2.9 34.9 19.5 40.8s34.9-2.9 40.8-19.5zM39 289.3c-5 1.5-9.8 4.2-13.7 8.2c-4 4-6.7 8.8-8.1 14c-.3 1.2-.6 2.5-.8 3.8c-.3 1.7-.4 3.4-.4 5.1L16 432c0 17.7 14.3 32 32 32s32-14.3 32-32l0-35.1 17.6 17.5c0 0 0 0 0 0c87.5 87.4 229.3 87.4 316.7 0c24.4-24.4 42.1-53.1 52.9-83.8c5.9-16.7-2.9-34.9-19.5-40.8s-34.9 2.9-40.8 19.5c-7.7 21.8-20.2 42.3-37.8 59.8c-62.5 62.5-163.8 62.5-226.3 0l-.1-.1L125.6 352l34.4 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L48.4 288c-1.6 0-3.2 .1-4.8 .3s-3.1 .5-4.6 1z" : "M94 187.1C120.8 124.1 183.3 80 256 80c39.7 0 77.8 15.8 105.9 43.9L414.1 176 360 176c-13.3 0-24 10.7-24 24s10.7 24 24 24l112 0c13.3 0 24-10.7 24-24l0-112c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 54.1L395.9 89.9C358.8 52.8 308.5 32 256 32C163.4 32 83.9 88.2 49.8 168.3c-5.2 12.2 .5 26.3 12.7 31.5s26.3-.5 31.5-12.7zm368 157c5.2-12.2-.4-26.3-12.6-31.5s-26.3 .4-31.5 12.6C391 388.1 328.6 432 256 432c-39.7 0-77.8-15.8-105.9-43.9L97.9 336l54.1 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L40 288c-13.3 0-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-54.1 52.1 52.1C153.2 459.2 203.5 480 256 480c92.5 0 171.8-56 206-135.9z"
        }
      )
    })
  );
});
D.displayName = "ArrowsRotateFAIcon";
const _ = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 384 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: d ? "M64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-288-128 0c-17.7 0-32-14.3-32-32L224 0 64 0zM256 0l0 128 128 0L256 0zM112 256l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z" : "M64 464c-8.8 0-16-7.2-16-16L48 64c0-8.8 7.2-16 16-16l160 0 0 80c0 17.7 14.3 32 32 32l80 0 0 288c0 8.8-7.2 16-16 16L64 464zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-293.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0L64 0zm56 256c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0z"
        }
      )
    })
  );
});
_.displayName = "FileLinesFarFAIcon";
const q = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 576 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: d ? "M0 96l576 0c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96zm0 32L0 416c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-288L0 128zM64 405.3c0-29.5 23.9-53.3 53.3-53.3l117.3 0c29.5 0 53.3 23.9 53.3 53.3c0 5.9-4.8 10.7-10.7 10.7L74.7 416c-5.9 0-10.7-4.8-10.7-10.7zM176 192a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm176 16c0-8.8 7.2-16 16-16l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16z" : "M528 160l0 256c0 8.8-7.2 16-16 16l-192 0c0-44.2-35.8-80-80-80l-64 0c-44.2 0-80 35.8-80 80l-32 0c-8.8 0-16-7.2-16-16l0-256 480 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM272 256a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm104-48c-13.3 0-24 10.7-24 24s10.7 24 24 24l80 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-80 0zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24l80 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-80 0z"
        }
      )
    })
  );
});
q.displayName = "IdCardFarFAIcon";
const O = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: d ? "M75 75L41 41C25.9 25.9 0 36.6 0 57.9L0 168c0 13.3 10.7 24 24 24l110.1 0c21.4 0 32.1-25.9 17-41l-30.8-30.8C155 85.5 203 64 256 64c106 0 192 86 192 192s-86 192-192 192c-40.8 0-78.6-12.7-109.7-34.4c-14.5-10.1-34.4-6.6-44.6 7.9s-6.6 34.4 7.9 44.6C151.2 495 201.7 512 256 512c141.4 0 256-114.6 256-256S397.4 0 256 0C185.3 0 121.3 28.7 75 75zm181 53c-13.3 0-24 10.7-24 24l0 104c0 6.4 2.5 12.5 7 17l72 72c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-65-65 0-94.1c0-13.3-10.7-24-24-24z" : "M48 106.7L48 56c0-13.3-10.7-24-24-24S0 42.7 0 56L0 168c0 13.3 10.7 24 24 24l112 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-55.3 0c37-57.8 101.7-96 175.3-96c114.9 0 208 93.1 208 208s-93.1 208-208 208c-42.5 0-81.9-12.7-114.7-34.5c-11-7.3-25.9-4.3-33.3 6.7s-4.3 25.9 6.7 33.3C155.2 496.4 203.8 512 256 512c141.4 0 256-114.6 256-256S397.4 0 256 0C170.3 0 94.4 42.1 48 106.7zM256 128c-13.3 0-24 10.7-24 24l0 104c0 6.4 2.5 12.5 7 17l72 72c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-65-65 0-94.1c0-13.3-10.7-24-24-24z"
        }
      )
    })
  );
});
O.displayName = "ClockRotateLeftFAIcon";
const Q = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 448 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: d ? "M0 64C0 46.3 14.3 32 32 32c229.8 0 416 186.2 416 416c0 17.7-14.3 32-32 32s-32-14.3-32-32C384 253.6 226.4 96 32 96C14.3 96 0 81.7 0 64zM0 416a64 64 0 1 1 128 0A64 64 0 1 1 0 416zM32 160c159.1 0 288 128.9 288 288c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-123.7-100.3-224-224-224c-17.7 0-32-14.3-32-32s14.3-32 32-32z" : "M0 56C0 42.7 10.7 32 24 32c234.2 0 424 189.8 424 424c0 13.3-10.7 24-24 24s-24-10.7-24-24C400 248.3 231.7 80 24 80C10.7 80 0 69.3 0 56zM64 432a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-80a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM24 176c154.6 0 280 125.4 280 280c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-128.1-103.9-232-232-232c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
        }
      )
    })
  );
});
Q.displayName = "RssFarFAIcon";
const j = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: d ? "M327.5 85.2c-4.5 1.7-7.5 6-7.5 10.8s3 9.1 7.5 10.8L384 128l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L448 128l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L448 64 426.8 7.5C425.1 3 420.8 0 416 0s-9.1 3-10.8 7.5L384 64 327.5 85.2zM205.1 73.3c-2.6-5.7-8.3-9.3-14.5-9.3s-11.9 3.6-14.5 9.3L123.3 187.3 9.3 240C3.6 242.6 0 248.3 0 254.6s3.6 11.9 9.3 14.5l114.1 52.7L176 435.8c2.6 5.7 8.3 9.3 14.5 9.3s11.9-3.6 14.5-9.3l52.7-114.1 114.1-52.7c5.7-2.6 9.3-8.3 9.3-14.5s-3.6-11.9-9.3-14.5L257.8 187.4 205.1 73.3zM384 384l-56.5 21.2c-4.5 1.7-7.5 6-7.5 10.8s3 9.1 7.5 10.8L384 448l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L448 448l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L448 384l-21.2-56.5c-1.7-4.5-6-7.5-10.8-7.5s-9.1 3-10.8 7.5L384 384z" : "M327.5 85.2c-4.5 1.7-7.5 6-7.5 10.8s3 9.1 7.5 10.8L384 128l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L448 128l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L448 64 426.8 7.5C425.1 3 420.8 0 416 0s-9.1 3-10.8 7.5L384 64 327.5 85.2zM9.3 240C3.6 242.6 0 248.3 0 254.6s3.6 11.9 9.3 14.5L26.3 277l8.1 3.7 .6 .3 88.3 40.8L164.1 410l.3 .6 3.7 8.1 7.9 17.1c2.6 5.7 8.3 9.3 14.5 9.3s11.9-3.6 14.5-9.3l7.9-17.1 3.7-8.1 .3-.6 40.8-88.3L346 281l.6-.3 8.1-3.7 17.1-7.9c5.7-2.6 9.3-8.3 9.3-14.5s-3.6-11.9-9.3-14.5l-17.1-7.9-8.1-3.7-.6-.3-88.3-40.8L217 99.1l-.3-.6L213 90.3l-7.9-17.1c-2.6-5.7-8.3-9.3-14.5-9.3s-11.9 3.6-14.5 9.3l-7.9 17.1-3.7 8.1-.3 .6-40.8 88.3L35.1 228.1l-.6 .3-8.1 3.7L9.3 240zm83 14.5l51.2-23.6c10.4-4.8 18.7-13.1 23.5-23.5l23.6-51.2 23.6 51.2c4.8 10.4 13.1 18.7 23.5 23.5l51.2 23.6-51.2 23.6c-10.4 4.8-18.7 13.1-23.5 23.5l-23.6 51.2-23.6-51.2c-4.8-10.4-13.1-18.7-23.5-23.5L92.3 254.6zM384 384l-56.5 21.2c-4.5 1.7-7.5 6-7.5 10.8s3 9.1 7.5 10.8L384 448l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L448 448l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L448 384l-21.2-56.5c-1.7-4.5-6-7.5-10.8-7.5s-9.1 3-10.8 7.5L384 384z"
        }
      )
    })
  );
});
j.displayName = "SparklesFarFAIcon";
const W = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: d ? "M320 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l82.7 0L201.4 265.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L448 109.3l0 82.7c0 17.7 14.3 32 32 32s32-14.3 32-32l0-160c0-17.7-14.3-32-32-32L320 0zM80 32C35.8 32 0 67.8 0 112L0 432c0 44.2 35.8 80 80 80l320 0c44.2 0 80-35.8 80-80l0-112c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 112c0 8.8-7.2 16-16 16L80 448c-8.8 0-16-7.2-16-16l0-320c0-8.8 7.2-16 16-16l112 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L80 32z" : "M304 24c0 13.3 10.7 24 24 24l102.1 0L207 271c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l223-223L464 184c0 13.3 10.7 24 24 24s24-10.7 24-24l0-160c0-13.3-10.7-24-24-24L328 0c-13.3 0-24 10.7-24 24zM72 32C32.2 32 0 64.2 0 104L0 440c0 39.8 32.2 72 72 72l336 0c39.8 0 72-32.2 72-72l0-128c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 128c0 13.3-10.7 24-24 24L72 464c-13.3 0-24-10.7-24-24l0-336c0-13.3 10.7-24 24-24l128 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L72 32z"
        }
      )
    })
  );
});
W.displayName = "ArrowUpRightFromSquareFarFAIcon";
const X = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 576 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: d ? "M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4C142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM144 256a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-64c0 35.3-28.7 64-64 64c-7.1 0-13.9-1.2-20.3-3.3c-5.5-1.8-11.9 1.6-11.7 7.4c.3 6.9 1.3 13.8 3.2 20.7c13.7 51.2 66.4 81.6 117.6 67.9s81.6-66.4 67.9-117.6c-11.1-41.5-47.8-69.4-88.6-71.1c-5.8-.2-9.2 6.1-7.4 11.7c2.1 6.4 3.3 13.2 3.3 20.3z" : "M288 80c-65.2 0-118.8 29.6-159.9 67.7C89.6 183.5 63 226 49.4 256c13.6 30 40.2 72.5 78.6 108.3C169.2 402.4 222.8 432 288 432s118.8-29.6 159.9-67.7C486.4 328.5 513 286 526.6 256c-13.6-30-40.2-72.5-78.6-108.3C406.8 109.6 353.2 80 288 80zM95.4 112.6C142.5 68.8 207.2 32 288 32s145.5 36.8 192.6 80.6c46.8 43.5 78.1 95.4 93 131.1c3.3 7.9 3.3 16.7 0 24.6c-14.9 35.7-46.2 87.7-93 131.1C433.5 443.2 368.8 480 288 480s-145.5-36.8-192.6-80.6C48.6 356 17.3 304 2.5 268.3c-3.3-7.9-3.3-16.7 0-24.6C17.3 208 48.6 156 95.4 112.6zM288 336c44.2 0 80-35.8 80-80s-35.8-80-80-80c-.7 0-1.3 0-2 0c1.3 5.1 2 10.5 2 16c0 35.3-28.7 64-64 64c-5.5 0-10.9-.7-16-2c0 .7 0 1.3 0 2c0 44.2 35.8 80 80 80zm0-208a128 128 0 1 1 0 256 128 128 0 1 1 0-256z"
        }
      )
    })
  );
});
X.displayName = "EyeFarFAIcon";
const J = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M208 48a160 160 0 1 1 0 320 160 160 0 1 1 0-320zm0 368c48.8 0 93.7-16.8 129.1-44.9L471 505c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L371.1 337.1C399.2 301.7 416 256.8 416 208C416 93.1 322.9 0 208 0S0 93.1 0 208S93.1 416 208 416zM184 296c0 13.3 10.7 24 24 24s24-10.7 24-24l0-64 64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-64 0 0-64c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 64-64 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l64 0 0 64z"
        }
      )
    })
  );
});
J.displayName = "MagnifyingGlassPlusFarFAIcon";
const K = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: d ? "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512z" : "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"
        }
      )
    })
  );
});
K.displayName = "CircleFarFAIcon";
const Y = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 448 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: d ? "M201.4 374.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 306.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z" : "M241 369c-9.4 9.4-24.6 9.4-33.9 0L47 209c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l143 143L367 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L241 369z"
        }
      )
    })
  );
});
Y.displayName = "AngleDownFarFAIcon";
const $ = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 320 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: d ? "M278.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-160 160c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L210.7 256 73.4 118.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l160 160z" : "M273 239c9.4 9.4 9.4 24.6 0 33.9L113 433c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l143-143L79 113c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L273 239z"
        }
      )
    })
  );
});
$.displayName = "AngleRightFarFAIcon";
const l2 = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 320 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: d ? "M41.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 256 246.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z" : "M47 239c-9.4 9.4-9.4 24.6 0 33.9L207 433c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L97.9 256 241 113c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L47 239z"
        }
      )
    })
  );
});
l2.displayName = "AngleLeftFarFAIcon";
const c2 = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM361 207l-88-88c-9.4-9.4-24.6-9.4-33.9 0l-88 88c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47L232 376c0 13.3 10.7 24 24 24s24-10.7 24-24l0-182.1 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9z"
        }
      )
    })
  );
});
c2.displayName = "CircleArrowUpFarFAIcon";
const r2 = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M256 48a208 208 0 1 0 0 416 208 208 0 1 0 0-416zm0 464A256 256 0 1 1 256 0a256 256 0 1 1 0 512zM361 305l-88 88c-9.4 9.4-24.6 9.4-33.9 0l-88-88c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L232 136c0-13.3 10.7-24 24-24s24 10.7 24 24l0 182.1 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"
        }
      )
    })
  );
});
r2.displayName = "CircleArrowDownFarFAIcon";
const e2 = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: d ? "M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM297 385c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l71-71L120 280c-13.3 0-24-10.7-24-24s10.7-24 24-24l214.1 0-71-71c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L409 239c9.4 9.4 9.4 24.6 0 33.9L297 385z" : "M464 256A208 208 0 1 1 48 256a208 208 0 1 1 416 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM305 361l88-88c9.4-9.4 9.4-24.6 0-33.9l-88-88c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l47 47L136 232c-13.3 0-24 10.7-24 24s10.7 24 24 24l182.1 0-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0z"
        }
      )
    })
  );
});
e2.displayName = "CircleArrowRightFarFAIcon";
const t2 = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: d ? "M512 256A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM215 127c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-71 71L392 232c13.3 0 24 10.7 24 24s-10.7 24-24 24l-214.1 0 71 71c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L103 273c-9.4-9.4-9.4-24.6 0-33.9L215 127z" : "M48 256a208 208 0 1 1 416 0A208 208 0 1 1 48 256zm464 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM207 151l-88 88c-9.4 9.4-9.4 24.6 0 33.9l88 88c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47L376 280c13.3 0 24-10.7 24-24s-10.7-24-24-24l-182.1 0 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0z"
        }
      )
    })
  );
});
t2.displayName = "CircleArrowLeftFarFAIcon";
const s2 = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: "M295 183c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l135-135 0 86.1c0 13.3 10.7 24 24 24s24-10.7 24-24l0-144c0-13.3-10.7-24-24-24L344 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l86.1 0L295 183zM217 329c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L48 430.1 48 344c0-13.3-10.7-24-24-24s-24 10.7-24 24L0 488c0 13.3 10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-86.1 0L217 329z"
        }
      )
    })
  );
});
s2.displayName = "ArrowUpRightAndArrowDownLeftFromCenterFarFAIcon";
const o2 = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: d ? "M320 488c0 9.5-5.6 18.1-14.2 21.9s-18.8 2.3-25.8-4.1l-80-72c-5.1-4.6-7.9-11-7.9-17.8s2.9-13.3 7.9-17.8l80-72c7-6.3 17.2-7.9 25.8-4.1s14.2 12.4 14.2 21.9l0 48 16 0c39.8 0 72-32.2 72-72l0-163.7c-32.5-10.2-56-40.5-56-76.3c0-44.2 35.8-80 80-80s80 35.8 80 80c0 35.8-23.5 66.1-56 76.3L456 320c0 66.3-53.7 120-120 120l-16 0 0 48zM464 80a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM192 24c0-9.5 5.6-18.1 14.2-21.9s18.8-2.3 25.8 4.1l80 72c5.1 4.6 7.9 11 7.9 17.8s-2.9 13.3-7.9 17.8l-80 72c-7 6.3-17.2 7.9-25.8 4.1s-14.2-12.4-14.2-21.9l0-48-16 0c-39.8 0-72 32.2-72 72l0 163.7c32.5 10.2 56 40.5 56 76.3c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-35.8 23.5-66.1 56-76.3L56 192c0-66.3 53.7-120 120-120l16 0 0-48zM48 432a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z" : "M320 488c0 9.5-5.6 18.1-14.2 21.9s-18.8 2.3-25.8-4.1l-80-72c-5.1-4.6-7.9-11-7.9-17.8s2.9-13.3 7.9-17.8l80-72c7-6.3 17.2-7.9 25.8-4.1s14.2 12.4 14.2 21.9l0 40 16 0c35.3 0 64-28.7 64-64l0-166.7C371.7 141 352 112.8 352 80c0-44.2 35.8-80 80-80s80 35.8 80 80c0 32.8-19.7 61-48 73.3L464 320c0 70.7-57.3 128-128 128l-16 0 0 40zM456 80a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM192 24c0-9.5 5.6-18.1 14.2-21.9s18.8-2.3 25.8 4.1l80 72c5.1 4.6 7.9 11 7.9 17.8s-2.9 13.3-7.9 17.8l-80 72c-7 6.3-17.2 7.9-25.8 4.1s-14.2-12.4-14.2-21.9l0-40-16 0c-35.3 0-64 28.7-64 64l0 166.7c28.3 12.3 48 40.5 48 73.3c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-32.8 19.7 61 48-73.3L48 192c0-70.7 57.3-128 128-128l16 0 0-40zM56 432a24 24 0 1 0 48 0 24 24 0 1 0 -48 0z"
        }
      )
    })
  );
});
o2.displayName = "CodeCompareFarFAIcon";
const i2 = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: d ? "M368.4 18.3c21.9-21.9 57.3-21.9 79.2 0l46.1 46.1c21.9 21.9 21.9 57.3 0 79.2l-71 71L412.2 225 371.6 374.1c-4.8 17.8-18.1 32-35.5 38.1L72 505c-18.5 6.5-39.1 1.8-52.9-12S.5 458.5 7 440L99.8 175.9c6.1-17.4 20.3-30.6 38.1-35.5L287 99.8l10.4-10.4 71-71zM296.9 146.8L150.5 186.7c-2.5 .7-4.6 2.6-5.4 5.1L62.5 426.9 164.7 324.7c-3-6.3-4.7-13.3-4.7-20.7c0-26.5 21.5-48 48-48s48 21.5 48 48s-21.5 48-48 48c-7.4 0-14.4-1.7-20.7-4.7L85.1 449.5l235.1-82.6c2.5-.9 4.4-2.9 5.1-5.4l39.9-146.4-68.3-68.3z" : "M368.4 18.3L312.7 74.1 437.9 199.3l55.7-55.7c21.9-21.9 21.9-57.3 0-79.2L447.6 18.3c-21.9-21.9-57.3-21.9-79.2 0zM288 94.6l-9.2 2.8L134.7 140.6c-19.9 6-35.7 21.2-42.3 41L3.8 445.8c-3.8 11.3-1 23.9 7.3 32.4L164.7 324.7c-3-6.3-4.7-13.3-4.7-20.7c0-26.5 21.5-48 48-48s48 21.5 48 48s-21.5 48-48 48c-7.4 0-14.4-1.7-20.7-4.7L33.7 500.9c8.6 8.3 21.1 11.2 32.4 7.3l264.3-88.6c19.7-6.6 35-22.4 41-42.3l43.2-144.1 2.7-9.2L288 94.6z"
        }
      )
    })
  );
});
i2.displayName = "PenNibFarFAIcon";
const a2 = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 640 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: d ? "M64 128l0 256 512 0 0-256L64 128zM0 128C0 92.7 28.7 64 64 64l512 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 448c-35.3 0-64-28.7-64-64L0 128zm184 32c9.5 0 18.1 5.6 21.9 14.3l64 144c5.4 12.1-.1 26.3-12.2 31.7s-26.3-.1-31.7-12.2l-4.3-9.7-75.5 0-4.3 9.7c-5.4 12.1-19.6 17.6-31.7 12.2s-17.6-19.6-12.2-31.7l64-144c3.9-8.7 12.4-14.3 21.9-14.3zm0 83.1L167.6 280l32.8 0L184 243.1zM304 184c0-13.3 10.7-24 24-24l52 0c33.1 0 60 26.9 60 60c0 9.2-2.1 17.9-5.8 25.7c13.3 11 21.8 27.6 21.8 46.3c0 33.1-26.9 60-60 60l-68 0c-13.3 0-24-10.7-24-24l0-8 0-64 0-64 0-8zm48 24l0 24 28 0c6.6 0 12-5.4 12-12s-5.4-12-12-12l-28 0zm0 96l44 0c6.6 0 12-5.4 12-12s-5.4-12-12-12l-16 0-28 0 0 24z" : "M64 112c-8.8 0-16 7.2-16 16l0 256c0 8.8 7.2 16 16 16l512 0c8.8 0 16-7.2 16-16l0-256c0-8.8-7.2-16-16-16L64 112zM0 128C0 92.7 28.7 64 64 64l512 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 448c-35.3 0-64-28.7-64-64L0 128zm184 32c9.5 0 18.1 5.6 21.9 14.3l64 144c5.4 12.1-.1 26.3-12.2 31.7s-26.3-.1-31.7-12.2l-4.3-9.7-75.5 0-4.3 9.7c-5.4 12.1-19.6 17.6-31.7 12.2s-17.6-19.6-12.2-31.7l64-144c3.9-8.7 12.4-14.3 21.9-14.3zm0 83.1L167.6 280l32.8 0L184 243.1zM304 184c0-13.3 10.7-24 24-24l52 0c33.1 0 60 26.9 60 60c0 9.2-2.1 17.9-5.8 25.7c13.3 11 21.8 27.6 21.8 46.3c0 33.1-26.9 60-60 60l-68 0c-13.3 0-24-10.7-24-24l0-8 0-64 0-64 0-8zm48 24l0 24 28 0c6.6 0 12-5.4 12-12s-5.4-12-12-12l-28 0zm0 96l44 0c6.6 0 12-5.4 12-12s-5.4-12-12-12l-16 0-28 0 0 24z"
        }
      )
    })
  );
});
a2.displayName = "InputTextFarFAIcon";
const h2 = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 448 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: d ? "M144 144l0 48 160 0 0-48c0-44.2-35.8-80-80-80s-80 35.8-80 80zM80 192l0-48C80 64.5 144.5 0 224 0s144 64.5 144 144l0 48 16 0c35.3 0 64 28.7 64 64l0 192c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 256c0-35.3 28.7-64 64-64l16 0z" : "M144 128l0 64 160 0 0-64c0-44.2-35.8-80-80-80s-80 35.8-80 80zM96 192l0-64C96 57.3 153.3 0 224 0s128 57.3 128 128l0 64 32 0c35.3 0 64 28.7 64 64l0 192c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 256c0-35.3 28.7-64 64-64l32 0zM48 256l0 192c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-192c0-8.8-7.2-16-16-16L64 240c-8.8 0-16 7.2-16 16z"
        }
      )
    })
  );
});
h2.displayName = "LockFarFAIcon";
const d2 = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: d ? "M32 32l448 0c17.7 0 32 14.3 32 32l0 32c0 17.7-14.3 32-32 32L32 128C14.3 128 0 113.7 0 96L0 64C0 46.3 14.3 32 32 32zm0 128l448 0 0 256c0 35.3-28.7 64-64 64L96 480c-35.3 0-64-28.7-64-64l0-256zm128 80c0 8.8 7.2 16 16 16l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-160 0c-8.8 0-16 7.2-16 16z" : "M48 80l0 48 416 0 0-48L48 80zM32 32l448 0c17.7 0 32 14.3 32 32l0 80c0 17.7-14.3 32-32 32L32 176c-17.7 0-32-14.3-32-32L0 64C0 46.3 14.3 32 32 32zM160 248c0-13.3 10.7-24 24-24l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24zM32 416l0-208 48 0 0 208c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-208 48 0 0 208c0 35.3-28.7 64-64 64L96 480c-35.3 0-64-28.7-64-64z"
        }
      )
    })
  );
});
d2.displayName = "ArchiveFarFAIcon";
const w2 = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: d ? "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 232l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z" : "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 232c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0z"
        }
      )
    })
  );
});
w2.displayName = "CircleMinusFarFAIcon";
const n2 = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 448 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: d ? "M201.4 137.4c12.5-12.5 32.8-12.5 45.3 0l160 160c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L224 205.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l160-160z" : "M207 143c9.4-9.4 24.6-9.4 33.9 0L401 303c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-143-143L81 337c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L207 143z"
        }
      )
    })
  );
});
n2.displayName = "AngleUpFarFAIcon";
const g2 = f.forwardRef((w, h) => {
  var c = w, { ariaHidden: r = "true", color: e, filled: d = !1, size: l = 16, style: i } = c, a = g(c, ["ariaHidden", "color", "filled", "size", "style"]);
  return /* @__PURE__ */ t(
    "svg",
    n(s({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 448 512",
      "aria-hidden": r,
      color: e,
      ref: h,
      role: "img",
      style: s({ width: o(l), height: o(l) }, i)
    }, a), {
      children: /* @__PURE__ */ t(
        "path",
        {
          fill: "currentColor",
          d: d ? "M135.2 17.7L128 32 32 32C14.3 32 0 46.3 0 64S14.3 96 32 96l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 0-7.2-14.3C307.4 6.8 296.3 0 284.2 0L163.8 0c-12.1 0-23.2 6.8-28.6 17.7zM416 128L32 128 53.2 467c1.6 25.3 22.6 45 47.9 45l245.8 0c25.3 0 46.3-19.7 47.9-45L416 128zM217.8 199.9c8.9 9.9 8.1 25-1.8 33.9L182.5 264l57.5 0c48.6 0 88 39.4 88 88l0 40c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-40c0-22.1-17.9-40-40-40l-57.5 0 33.5 30.2c9.9 8.9 10.7 24 1.8 33.9s-24 10.7-33.9 1.8l-80-72c-5.1-4.6-7.9-11-7.9-17.8s2.9-13.3 7.9-17.8l80-72c9.9-8.9 25-8.1 33.9 1.8z" : "M177.1 48l93.7 0c2.7 0 5.2 1.3 6.7 3.6l19 28.4-145 0 19-28.4c1.5-2.2 4-3.6 6.7-3.6zM354.2 80L317.5 24.9C307.1 9.4 289.6 0 270.9 0L177.1 0c-18.7 0-36.2 9.4-46.6 24.9L93.8 80 80.1 80 32 80l-8 0C10.7 80 0 90.7 0 104s10.7 24 24 24l11.6 0L59.6 452.7c2.5 33.4 30.3 59.3 63.8 59.3l201.1 0c33.5 0 61.3-25.9 63.8-59.3L412.4 128l11.6 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0-48.1 0-13.7 0zm10.1 48L340.5 449.2c-.6 8.4-7.6 14.8-16 14.8l-201.1 0c-8.4 0-15.3-6.5-16-14.8L83.7 128l280.6 0zM222.9 194.7c-7.3-8.3-20-9-28.2-1.7l-72 64c-4.3 3.8-6.7 9.2-6.7 14.9s2.4 11.2 6.7 14.9l72 64c8.3 7.3 20.9 6.6 28.2-1.7s6.6-20.9-1.7-28.2L188.6 292l51.4 0c24.3 0 44 19.7 44 44l0 24c0 11 9 20 20 20s20-9 20-20l0-24c0-46.4-37.6-84-84-84l-51.4 0 32.7-29.1c8.3-7.3 9-20 1.7-28.2z"
        }
      )
    })
  );
});
g2.displayName = "TrashUndoFarFAIcon";
export {
  W1 as AlignCenterFAIcon,
  J1 as AlignJustifyFAIcon,
  j1 as AlignLeftFAIcon,
  X1 as AlignRightFAIcon,
  Y as AngleDownFarFAIcon,
  l2 as AngleLeftFarFAIcon,
  $ as AngleRightFarFAIcon,
  n2 as AngleUpFarFAIcon,
  d2 as ArchiveFarFAIcon,
  R1 as ArrowDownFarFAIcon,
  O2 as ArrowFromBottomFarFAIcon,
  S2 as ArrowLeftFAIcon,
  g4 as ArrowLeftToLineFAIcon,
  W2 as ArrowRightFarFAIcon,
  f4 as ArrowRightToLineFAIcon,
  y as ArrowRotateLeftFAIcon,
  A as ArrowRotateRightFAIcon,
  n1 as ArrowToBottomFarFAIcon,
  I1 as ArrowUpFarFAIcon,
  s2 as ArrowUpRightAndArrowDownLeftFromCenterFarFAIcon,
  W as ArrowUpRightFromSquareFarFAIcon,
  L4 as ArrowUpToLineFAIcon,
  D as ArrowsRotateFAIcon,
  R2 as BellFarFAIcon,
  h1 as BlueskyFAIcon,
  T1 as BoldFasFAIcon,
  E as BuildingFarFAIcon,
  C1 as CalendarDayFarFAIcon,
  o1 as CalendarFarFAIcon,
  c4 as CaretDownFasFAIcon,
  A4 as ChartBarFarFAIcon,
  p1 as ChartLineFarFAIcon,
  x4 as ChartPieFarFAIcon,
  _2 as CheckCircleFarFAIcon,
  A2 as CheckFarFAIcon,
  x1 as ChevronDownFarFAIcon,
  Q2 as ChevronLeftFAIcon,
  j2 as ChevronRightFAIcon,
  A1 as ChevronUpFarFAIcon,
  r2 as CircleArrowDownFarFAIcon,
  t2 as CircleArrowLeftFarFAIcon,
  e2 as CircleArrowRightFarFAIcon,
  c2 as CircleArrowUpFarFAIcon,
  z2 as CircleExclamationFarFAIcon,
  K as CircleFarFAIcon,
  v2 as CircleInfoFarFAIcon,
  w2 as CircleMinusFarFAIcon,
  V2 as CircleQuestionFarFAIcon,
  p2 as CircleXmarkFarFAIcon,
  v1 as ClockFarFAIcon,
  O as ClockRotateLeftFAIcon,
  o2 as CodeCompareFarFAIcon,
  o4 as CodeFarFAIcon,
  i4 as CodeFasFAIcon,
  u2 as CogFarFAIcon,
  E2 as CommentFarFAIcon,
  Z as CopilotIcon,
  w1 as CopyFarFAIcon,
  m1 as CreditCardFarFAIcon,
  u1 as CrosshairsFarFAIcon,
  M1 as EllipsisVerticalFarFAIcon,
  G2 as EnvelopeFarFAIcon,
  P2 as EnvelopeOpenFarFAIcon,
  a4 as EraserFasFAIcon,
  X as EyeFarFAIcon,
  r1 as FacebookFarFAIcon,
  i1 as FavoriteFarFAIcon,
  q2 as FileAltFarFAIcon,
  S as FileExcelFarFAIcon,
  I as FileFarFAIcon,
  _ as FileLinesFarFAIcon,
  V as FilePdfFarFAIcon,
  N as FilePowerPointFarFAIcon,
  Z2 as FileTextFarFAIcon,
  H as FileWordFarFAIcon,
  k as FileZipFarFAIcon,
  U as FilterFarFAIcon,
  b as FilterSlashFarFAIcon,
  b2 as FolderFarFAIcon,
  l4 as FontFasFAIcon,
  F1 as GearFarFAIcon,
  H2 as GlobeFarFAIcon,
  z as Grid2FarFAIcon,
  n4 as GridFarFAIcon,
  y1 as GripVerticalFarFAIcon,
  E1 as H1FasFAIcon,
  Z1 as H2FasFAIcon,
  G1 as H3FasFAIcon,
  D1 as H4FasFAIcon,
  _1 as H5FasFAIcon,
  q1 as H6FasFAIcon,
  G as HandshakeFarFAIcon,
  r4 as HighlighterFasFAIcon,
  k2 as HomeFarFAIcon,
  q as IdCardFarFAIcon,
  R as ImageFarFAIcon,
  e4 as ImageFasFAIcon,
  a2 as InputTextFarFAIcon,
  t1 as InstagramFarFAIcon,
  P1 as ItalicFasFAIcon,
  x as LayerGroupFarFAIcon,
  h4 as LineHeightFasFAIcon,
  K1 as LinkFarFAIcon,
  Y1 as LinkSlashFarFAIcon,
  e1 as LinkedInFarFAIcon,
  d4 as ListFarFAIcon,
  Q1 as ListOlFAIcon,
  O1 as ListUlFAIcon,
  U2 as LocationFarFAIcon,
  h2 as LockFarFAIcon,
  B1 as MagnifyingGlassFarFAIcon,
  J as MagnifyingGlassPlusFarFAIcon,
  V1 as MapFarFAIcon,
  C4 as MergeFAIcon,
  u4 as MinusSolidFAIcon,
  H1 as PaintBrushFarFAIcon,
  N1 as PaletteFarFAIcon,
  f1 as PaperPlaneTopFarFAIcon,
  d1 as PenFarFAIcon,
  k1 as PenFieldFarFAIcon,
  i2 as PenNibFarFAIcon,
  K2 as PlayFarFAIcon,
  N2 as PlusFarFAIcon,
  F4 as PlusFasFAIcon,
  y4 as PuzzlePieceSolidFAIcon,
  B2 as QLogo,
  t4 as QuoteLeftFasFAIcon,
  D2 as ReceiptFarFAIcon,
  Q as RssFarFAIcon,
  y2 as SearchFarFAIcon,
  l1 as ShareFarFAIcon,
  L1 as ShieldFarFAIcon,
  j as SparklesFarFAIcon,
  v4 as SplitFAIcon,
  g1 as SquareKanbanFarFAIcon,
  m4 as SquarePlusFarFAIcon,
  I2 as StarFarFAIcon,
  U1 as StrikeThroughFasFAIcon,
  w4 as TableFarFAIcon,
  z4 as TableLayoutCirclePlusFasFAIcon,
  M4 as TableLayoutFasFAIcon,
  S1 as TableListFarFAIcon,
  p4 as TableListFasFAIcon,
  $1 as TextSizeFasFAIcon,
  b1 as TextSlashFasFAIcon,
  a1 as ThreadsFAIcon,
  P as ThumbTackFarFAIcon,
  $2 as ThumbsDownFarFAIcon,
  Y2 as ThumbsUpFarFAIcon,
  s1 as TrashFarFAIcon,
  g2 as TrashUndoFarFAIcon,
  M2 as TriangleExclamationFarFAIcon,
  c1 as TwitterFarFAIcon,
  s4 as UnderlineFasFAIcon,
  T2 as UserCircleFarFAIcon,
  x2 as UserFarFAIcon,
  X2 as UserLargeFarFAIcon,
  z1 as UsersFarFAIcon,
  B as VideoFarFAIcon,
  T as VolumeFarFAIcon,
  F2 as XMarkFarFAIcon,
  J2 as YouTubeFarFAIcon
};
